/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as PlayerRouteRouteImport } from "./routes/player/route"
import { Route as DashboardRouteRouteImport } from "./routes/_dashboard/route"
import { Route as DashboardIndexRouteImport } from "./routes/_dashboard/index"
import { Route as PlayerIdRouteImport } from "./routes/player/$id"
import { Route as DashboardStartRouteImport } from "./routes/_dashboard/start"
import { Route as DashboardIntroVideoRouteImport } from "./routes/_dashboard/intro-video"
import { Route as DashboardBuyCreditsRouteImport } from "./routes/_dashboard/buy-credits"
import { Route as DashboardSettingsRouteRouteImport } from "./routes/_dashboard/settings/route"
import { Route as DashboardLeadsRouteRouteImport } from "./routes/_dashboard/leads/route"
import { Route as DashboardHiddenRouteRouteImport } from "./routes/_dashboard/hidden/route"
import { Route as DashboardSettingsIndexRouteImport } from "./routes/_dashboard/settings/index"
import { Route as DashboardPerformanceIndexRouteImport } from "./routes/_dashboard/performance/index"
import { Route as DashboardLeadsIndexRouteImport } from "./routes/_dashboard/leads/index"
import { Route as DashboardCampaignsIndexRouteImport } from "./routes/_dashboard/campaigns/index"
import { Route as DashboardSettingsAdminRouteRouteImport } from "./routes/_dashboard/settings/_admin/route"
import { Route as DashboardCampaignsSetupRouteRouteImport } from "./routes/_dashboard/campaigns/setup/route"
import { Route as DashboardCampaignsIdRouteRouteImport } from "./routes/_dashboard/campaigns/$id/route"
import { Route as DashboardCampaignsIdIndexRouteImport } from "./routes/_dashboard/campaigns/$id/index"
import { Route as DashboardSettingsProfileProfileRouteImport } from "./routes/_dashboard/settings/profile/_profile"
import { Route as DashboardSettingsAdminStopListsRouteRouteImport } from "./routes/_dashboard/settings/_admin/stop-lists/route"
import { Route as DashboardSettingsAdminIntegrationsRouteRouteImport } from "./routes/_dashboard/settings/_admin/integrations/route"
import { Route as DashboardSettingsAdminDisabledRouteRouteImport } from "./routes/_dashboard/settings/_admin/_disabled/route"
import { Route as DashboardCampaignsSetupPlanningRouteRouteImport } from "./routes/_dashboard/campaigns/setup/planning/route"
import { Route as DashboardCampaignsSetupDeliveryRouteRouteImport } from "./routes/_dashboard/campaigns/setup/delivery/route"
import { Route as DashboardCampaignsSetupDefineRouteRouteImport } from "./routes/_dashboard/campaigns/setup/define/route"
import { Route as DashboardCampaignsIdeditRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/route"
import { Route as DashboardSettingsProfileProfileIndexRouteImport } from "./routes/_dashboard/settings/profile/_profile.index"
import { Route as DashboardSettingsAdminStopListsIndexRouteImport } from "./routes/_dashboard/settings/_admin/stop-lists/index"
import { Route as DashboardSettingsAdminIntegrationsIndexRouteImport } from "./routes/_dashboard/settings/_admin/integrations/index"
import { Route as DashboardSettingsAdminCompanyIndexRouteImport } from "./routes/_dashboard/settings/_admin/company/index"
import { Route as DashboardCampaignsSetupSummaryIndexRouteImport } from "./routes/_dashboard/campaigns/setup/summary/index"
import { Route as DashboardCampaignsSetupDetailsIndexRouteImport } from "./routes/_dashboard/campaigns/setup/details/index"
import { Route as DashboardCampaignsSetupDefineIndexRouteImport } from "./routes/_dashboard/campaigns/setup/define/index"
import { Route as DashboardSettingsAdminUsersUsersRouteImport } from "./routes/_dashboard/settings/_admin/users/_users"
import { Route as DashboardSettingsAdminSubscriptionSubscriptionRouteImport } from "./routes/_dashboard/settings/_admin/subscription/_subscription"
import { Route as DashboardCampaignsSetupSummaryBuyCreditsRouteImport } from "./routes/_dashboard/campaigns/setup/summary/buy-credits"
import { Route as DashboardCampaignsSetupPlanningTypeRouteImport } from "./routes/_dashboard/campaigns/setup/planning/type"
import { Route as DashboardCampaignsSetupPlanningSalesStrategyAndPrioritizationRouteImport } from "./routes/_dashboard/campaigns/setup/planning/sales-strategy-and-prioritization"
import { Route as DashboardCampaignsSetupPlanningLeadAmountAndPeriodRouteImport } from "./routes/_dashboard/campaigns/setup/planning/lead-amount-and-period"
import { Route as DashboardCampaignsSetupPlanningLeadAmountRouteImport } from "./routes/_dashboard/campaigns/setup/planning/lead-amount"
import { Route as DashboardCampaignsSetupPlanningContactInformationRouteImport } from "./routes/_dashboard/campaigns/setup/planning/contact-information"
import { Route as DashboardCampaignsSetupDeliveryMethodRouteImport } from "./routes/_dashboard/campaigns/setup/delivery/method"
import { Route as DashboardCampaignsSetupDeliveryConfigureRouteImport } from "./routes/_dashboard/campaigns/setup/delivery/configure"
import { Route as DashboardCampaignsSetupDefineStopListsRouteImport } from "./routes/_dashboard/campaigns/setup/define/stop-lists"
import { Route as DashboardCampaignsIdeditDetailsRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/details"
import { Route as DashboardCampaignsSetupPlanningTriggersRouteRouteImport } from "./routes/_dashboard/campaigns/setup/planning/triggers/route"
import { Route as DashboardCampaignsSetupDeliveryIntegrationRouteRouteImport } from "./routes/_dashboard/campaigns/setup/delivery/integration/route"
import { Route as DashboardCampaignsSetupDefineAdvancedRouteRouteImport } from "./routes/_dashboard/campaigns/setup/define/advanced/route"
import { Route as DashboardCampaignsSetupDefineCategoryRouteRouteImport } from "./routes/_dashboard/campaigns/setup/define/$category/route"
import { Route as DashboardCampaignsIdeditStartCampaignRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/start-campaign/route"
import { Route as DashboardCampaignsIdeditPlanningRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/planning/route"
import { Route as DashboardCampaignsIdeditDeliveryRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/delivery/route"
import { Route as DashboardCampaignsIdeditDefineRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/define/route"
import { Route as DashboardCampaignsIdeditBoostRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/boost/route"
import { Route as DashboardSettingsAdminUsersUsersIndexRouteImport } from "./routes/_dashboard/settings/_admin/users/_users.index"
import { Route as DashboardSettingsAdminUsersIdIndexRouteImport } from "./routes/_dashboard/settings/_admin/users/$id/index"
import { Route as DashboardSettingsAdminSubscriptionSubscriptionIndexRouteImport } from "./routes/_dashboard/settings/_admin/subscription/_subscription.index"
import { Route as DashboardSettingsAdminStopListsIdIndexRouteImport } from "./routes/_dashboard/settings/_admin/stop-lists/$id/index"
import { Route as DashboardSettingsAdminDisabledInvoicesIndexRouteImport } from "./routes/_dashboard/settings/_admin/_disabled/invoices/index"
import { Route as DashboardCampaignsSetupPlanningTriggersIndexRouteImport } from "./routes/_dashboard/campaigns/setup/planning/triggers/index"
import { Route as DashboardCampaignsSetupDefineAdvancedIndexRouteImport } from "./routes/_dashboard/campaigns/setup/define/advanced/index"
import { Route as DashboardCampaignsSetupDefineCategoryIndexRouteImport } from "./routes/_dashboard/campaigns/setup/define/$category/index"
import { Route as DashboardCampaignsIdeditStartCampaignIndexRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/start-campaign/index"
import { Route as DashboardCampaignsIdeditDeliveryIndexRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/delivery/index"
import { Route as DashboardCampaignsIdeditDefineIndexRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/define/index"
import { Route as DashboardSettingsAdminUsersUsersInviteNewRouteImport } from "./routes/_dashboard/settings/_admin/users/_users.invite-new"
import { Route as DashboardSettingsAdminUsersUsersAddUsersRouteImport } from "./routes/_dashboard/settings/_admin/users/_users.add-users"
import { Route as DashboardSettingsAdminSubscriptionSubscriptionCreditUsageRouteImport } from "./routes/_dashboard/settings/_admin/subscription/_subscription.credit-usage"
import { Route as DashboardSettingsAdminSubscriptionSubscriptionAddUsersRouteImport } from "./routes/_dashboard/settings/_admin/subscription/_subscription.add-users"
import { Route as DashboardSettingsAdminSubscriptionSubscriptionAddCreditsRouteImport } from "./routes/_dashboard/settings/_admin/subscription/_subscription.add-credits"
import { Route as DashboardSettingsAdminIntegrationsIntegrationSettingsRouteImport } from "./routes/_dashboard/settings/_admin/integrations/$integration/settings"
import { Route as DashboardSettingsAdminIntegrationsIntegrationConnectRouteImport } from "./routes/_dashboard/settings/_admin/integrations/$integration/connect"
import { Route as DashboardCampaignsSetupPlanningTriggersTriggerIdRouteImport } from "./routes/_dashboard/campaigns/setup/planning/triggers/$triggerId"
import { Route as DashboardCampaignsSetupDeliveryIntegrationMethodRouteImport } from "./routes/_dashboard/campaigns/setup/delivery/integration/method"
import { Route as DashboardCampaignsSetupDeliveryIntegrationConfigureRouteImport } from "./routes/_dashboard/campaigns/setup/delivery/integration/configure"
import { Route as DashboardCampaignsSetupDefineCategoryContactsRouteImport } from "./routes/_dashboard/campaigns/setup/define/$category/contacts"
import { Route as DashboardCampaignsSetupDefineCategoryFilterRouteImport } from "./routes/_dashboard/campaigns/setup/define/$category/$filter"
import { Route as DashboardCampaignsIdeditStartCampaignBuyCreditsRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/start-campaign/buy-credits"
import { Route as DashboardCampaignsIdeditPlanningSalesStrategyAndPrioritizationRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/planning/sales-strategy-and-prioritization"
import { Route as DashboardCampaignsIdeditDeliveryBuyCreditsRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/delivery/buy-credits"
import { Route as DashboardCampaignsIdeditDefineStopListsRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/define/stop-lists"
import { Route as DashboardCampaignsIdeditBoostLeadAmountRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/boost/lead-amount"
import { Route as DashboardCampaignsIdeditBoostContactInformationRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/boost/contact-information"
import { Route as DashboardCampaignsIdeditBoostBuyCreditsRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/boost/buy-credits"
import { Route as DashboardCampaignsSetupDeliveryIntegrationSelectRouteRouteImport } from "./routes/_dashboard/campaigns/setup/delivery/integration/select/route"
import { Route as DashboardCampaignsSetupDefineAdvancedQualityRouteRouteImport } from "./routes/_dashboard/campaigns/setup/define/advanced/$quality/route"
import { Route as DashboardCampaignsIdeditPlanningTriggersRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/planning/triggers/route"
import { Route as DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period/route"
import { Route as DashboardCampaignsIdeditPlanningContactInformationRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/planning/contact-information/route"
import { Route as DashboardCampaignsIdeditDeliverySetupRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/delivery/setup/route"
import { Route as DashboardCampaignsIdeditDefineAdvancedRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/define/advanced/route"
import { Route as DashboardCampaignsIdeditDefineCategoryRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/define/$category/route"
import { Route as DashboardCampaignsIdeditAdjustWeekWeekStartRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart/route"
import { Route as DashboardSettingsAdminIntegrationsIntegrationModeIndexRouteImport } from "./routes/_dashboard/settings/_admin/integrations/$integration/$mode/index"
import { Route as DashboardCampaignsSetupDeliveryIntegrationSelectIndexRouteImport } from "./routes/_dashboard/campaigns/setup/delivery/integration/select/index"
import { Route as DashboardCampaignsIdeditPlanningTriggersIndexRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/planning/triggers/index"
import { Route as DashboardCampaignsIdeditPlanningLeadAmountAndPeriodIndexRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period/index"
import { Route as DashboardCampaignsIdeditPlanningContactInformationIndexRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/planning/contact-information/index"
import { Route as DashboardCampaignsIdeditDefineAdvancedIndexRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/define/advanced/index"
import { Route as DashboardCampaignsIdeditDefineCategoryIndexRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/define/$category/index"
import { Route as DashboardCampaignsIdeditAdjustWeekWeekStartIndexRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart/index"
import { Route as DashboardCampaignsSetupDeliveryIntegrationSelectNewRouteImport } from "./routes/_dashboard/campaigns/setup/delivery/integration/select/new"
import { Route as DashboardCampaignsIdeditPlanningTriggersTriggerIdRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/planning/triggers/$triggerId"
import { Route as DashboardCampaignsIdeditPlanningLeadAmountAndPeriodBuyCreditsRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period/buy-credits"
import { Route as DashboardCampaignsIdeditPlanningContactInformationBuyCreditsRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/planning/contact-information/buy-credits"
import { Route as DashboardCampaignsIdeditDeliverySetupMethodRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/delivery/setup/method"
import { Route as DashboardCampaignsIdeditDeliverySetupConfigureRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/delivery/setup/configure"
import { Route as DashboardCampaignsIdeditDeliverySetupBuyCreditsRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/delivery/setup/buy-credits"
import { Route as DashboardCampaignsIdeditDefineCategoryContactsRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/define/$category/contacts"
import { Route as DashboardCampaignsIdeditDefineCategoryFilterRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/define/$category/$filter"
import { Route as DashboardCampaignsIdeditAdjustWeekWeekStartBuyCreditsRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart/buy-credits"
import { Route as DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRouteImport } from "./routes/_dashboard/campaigns/setup/define/advanced/$quality/$category/route"
import { Route as DashboardCampaignsIdeditDeliverySetupIntegrationRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/route"
import { Route as DashboardCampaignsIdeditDefineAdvancedQualityRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/route"
import { Route as DashboardCampaignsSetupDefineAdvancedQualityCategoryContactsRouteImport } from "./routes/_dashboard/campaigns/setup/define/advanced/$quality/$category/contacts"
import { Route as DashboardCampaignsSetupDefineAdvancedQualityCategoryFilterRouteImport } from "./routes/_dashboard/campaigns/setup/define/advanced/$quality/$category/$filter"
import { Route as DashboardCampaignsIdeditDeliverySetupIntegrationMethodRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/method"
import { Route as DashboardCampaignsIdeditDeliverySetupIntegrationConfigureRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/configure"
import { Route as DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select/route"
import { Route as DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category/route"
import { Route as DashboardCampaignsIdeditDeliverySetupIntegrationSelectIndexRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select/index"
import { Route as DashboardCampaignsIdeditDeliverySetupIntegrationSelectNewRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select/new"
import { Route as DashboardCampaignsIdeditDefineAdvancedQualityCategoryContactsRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category/contacts"
import { Route as DashboardCampaignsIdeditDefineAdvancedQualityCategoryFilterRouteImport } from "./routes/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category/$filter"

const PlayerRouteRoute = PlayerRouteRouteImport.update({
  id: "/player",
  path: "/player",
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: "/_dashboard",
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashboardRouteRoute,
} as any)
const PlayerIdRoute = PlayerIdRouteImport.update({
  id: "/$id",
  path: "/$id",
  getParentRoute: () => PlayerRouteRoute,
} as any)
const DashboardStartRoute = DashboardStartRouteImport.update({
  id: "/start",
  path: "/start",
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardIntroVideoRoute = DashboardIntroVideoRouteImport.update({
  id: "/intro-video",
  path: "/intro-video",
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardBuyCreditsRoute = DashboardBuyCreditsRouteImport.update({
  id: "/buy-credits",
  path: "/buy-credits",
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSettingsRouteRoute = DashboardSettingsRouteRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardLeadsRouteRoute = DashboardLeadsRouteRouteImport.update({
  id: "/leads",
  path: "/leads",
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardHiddenRouteRoute = DashboardHiddenRouteRouteImport.update({
  id: "/hidden",
  path: "/hidden",
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashboardSettingsRouteRoute,
} as any)
const DashboardPerformanceIndexRoute =
  DashboardPerformanceIndexRouteImport.update({
    id: "/performance/",
    path: "/performance/",
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardLeadsIndexRoute = DashboardLeadsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DashboardLeadsRouteRoute,
} as any)
const DashboardCampaignsIndexRoute = DashboardCampaignsIndexRouteImport.update({
  id: "/campaigns/",
  path: "/campaigns/",
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSettingsAdminRouteRoute =
  DashboardSettingsAdminRouteRouteImport.update({
    id: "/_admin",
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)
const DashboardCampaignsSetupRouteRoute =
  DashboardCampaignsSetupRouteRouteImport.update({
    id: "/campaigns/setup",
    path: "/campaigns/setup",
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCampaignsIdRouteRoute =
  DashboardCampaignsIdRouteRouteImport.update({
    id: "/campaigns/$id",
    path: "/campaigns/$id",
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCampaignsIdIndexRoute =
  DashboardCampaignsIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardCampaignsIdRouteRoute,
  } as any)
const DashboardSettingsProfileProfileRoute =
  DashboardSettingsProfileProfileRouteImport.update({
    id: "/profile/_profile",
    path: "/profile",
    getParentRoute: () => DashboardSettingsRouteRoute,
  } as any)
const DashboardSettingsAdminStopListsRouteRoute =
  DashboardSettingsAdminStopListsRouteRouteImport.update({
    id: "/stop-lists",
    path: "/stop-lists",
    getParentRoute: () => DashboardSettingsAdminRouteRoute,
  } as any)
const DashboardSettingsAdminIntegrationsRouteRoute =
  DashboardSettingsAdminIntegrationsRouteRouteImport.update({
    id: "/integrations",
    path: "/integrations",
    getParentRoute: () => DashboardSettingsAdminRouteRoute,
  } as any)
const DashboardSettingsAdminDisabledRouteRoute =
  DashboardSettingsAdminDisabledRouteRouteImport.update({
    id: "/_disabled",
    getParentRoute: () => DashboardSettingsAdminRouteRoute,
  } as any)
const DashboardCampaignsSetupPlanningRouteRoute =
  DashboardCampaignsSetupPlanningRouteRouteImport.update({
    id: "/planning",
    path: "/planning",
    getParentRoute: () => DashboardCampaignsSetupRouteRoute,
  } as any)
const DashboardCampaignsSetupDeliveryRouteRoute =
  DashboardCampaignsSetupDeliveryRouteRouteImport.update({
    id: "/delivery",
    path: "/delivery",
    getParentRoute: () => DashboardCampaignsSetupRouteRoute,
  } as any)
const DashboardCampaignsSetupDefineRouteRoute =
  DashboardCampaignsSetupDefineRouteRouteImport.update({
    id: "/define",
    path: "/define",
    getParentRoute: () => DashboardCampaignsSetupRouteRoute,
  } as any)
const DashboardCampaignsIdeditRouteRoute =
  DashboardCampaignsIdeditRouteRouteImport.update({
    id: "/(edit)",
    getParentRoute: () => DashboardCampaignsIdRouteRoute,
  } as any)
const DashboardSettingsProfileProfileIndexRoute =
  DashboardSettingsProfileProfileIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardSettingsProfileProfileRoute,
  } as any)
const DashboardSettingsAdminStopListsIndexRoute =
  DashboardSettingsAdminStopListsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardSettingsAdminStopListsRouteRoute,
  } as any)
const DashboardSettingsAdminIntegrationsIndexRoute =
  DashboardSettingsAdminIntegrationsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardSettingsAdminIntegrationsRouteRoute,
  } as any)
const DashboardSettingsAdminCompanyIndexRoute =
  DashboardSettingsAdminCompanyIndexRouteImport.update({
    id: "/company/",
    path: "/company/",
    getParentRoute: () => DashboardSettingsAdminRouteRoute,
  } as any)
const DashboardCampaignsSetupSummaryIndexRoute =
  DashboardCampaignsSetupSummaryIndexRouteImport.update({
    id: "/summary/",
    path: "/summary/",
    getParentRoute: () => DashboardCampaignsSetupRouteRoute,
  } as any)
const DashboardCampaignsSetupDetailsIndexRoute =
  DashboardCampaignsSetupDetailsIndexRouteImport.update({
    id: "/details/",
    path: "/details/",
    getParentRoute: () => DashboardCampaignsSetupRouteRoute,
  } as any)
const DashboardCampaignsSetupDefineIndexRoute =
  DashboardCampaignsSetupDefineIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardCampaignsSetupDefineRouteRoute,
  } as any)
const DashboardSettingsAdminUsersUsersRoute =
  DashboardSettingsAdminUsersUsersRouteImport.update({
    id: "/users/_users",
    path: "/users",
    getParentRoute: () => DashboardSettingsAdminRouteRoute,
  } as any)
const DashboardSettingsAdminSubscriptionSubscriptionRoute =
  DashboardSettingsAdminSubscriptionSubscriptionRouteImport.update({
    id: "/subscription/_subscription",
    path: "/subscription",
    getParentRoute: () => DashboardSettingsAdminRouteRoute,
  } as any)
const DashboardCampaignsSetupSummaryBuyCreditsRoute =
  DashboardCampaignsSetupSummaryBuyCreditsRouteImport.update({
    id: "/summary/buy-credits",
    path: "/summary/buy-credits",
    getParentRoute: () => DashboardCampaignsSetupRouteRoute,
  } as any)
const DashboardCampaignsSetupPlanningTypeRoute =
  DashboardCampaignsSetupPlanningTypeRouteImport.update({
    id: "/type",
    path: "/type",
    getParentRoute: () => DashboardCampaignsSetupPlanningRouteRoute,
  } as any)
const DashboardCampaignsSetupPlanningSalesStrategyAndPrioritizationRoute =
  DashboardCampaignsSetupPlanningSalesStrategyAndPrioritizationRouteImport.update(
    {
      id: "/sales-strategy-and-prioritization",
      path: "/sales-strategy-and-prioritization",
      getParentRoute: () => DashboardCampaignsSetupPlanningRouteRoute,
    } as any,
  )
const DashboardCampaignsSetupPlanningLeadAmountAndPeriodRoute =
  DashboardCampaignsSetupPlanningLeadAmountAndPeriodRouteImport.update({
    id: "/lead-amount-and-period",
    path: "/lead-amount-and-period",
    getParentRoute: () => DashboardCampaignsSetupPlanningRouteRoute,
  } as any)
const DashboardCampaignsSetupPlanningLeadAmountRoute =
  DashboardCampaignsSetupPlanningLeadAmountRouteImport.update({
    id: "/lead-amount",
    path: "/lead-amount",
    getParentRoute: () => DashboardCampaignsSetupPlanningRouteRoute,
  } as any)
const DashboardCampaignsSetupPlanningContactInformationRoute =
  DashboardCampaignsSetupPlanningContactInformationRouteImport.update({
    id: "/contact-information",
    path: "/contact-information",
    getParentRoute: () => DashboardCampaignsSetupPlanningRouteRoute,
  } as any)
const DashboardCampaignsSetupDeliveryMethodRoute =
  DashboardCampaignsSetupDeliveryMethodRouteImport.update({
    id: "/method",
    path: "/method",
    getParentRoute: () => DashboardCampaignsSetupDeliveryRouteRoute,
  } as any)
const DashboardCampaignsSetupDeliveryConfigureRoute =
  DashboardCampaignsSetupDeliveryConfigureRouteImport.update({
    id: "/configure",
    path: "/configure",
    getParentRoute: () => DashboardCampaignsSetupDeliveryRouteRoute,
  } as any)
const DashboardCampaignsSetupDefineStopListsRoute =
  DashboardCampaignsSetupDefineStopListsRouteImport.update({
    id: "/stop-lists",
    path: "/stop-lists",
    getParentRoute: () => DashboardCampaignsSetupDefineRouteRoute,
  } as any)
const DashboardCampaignsIdeditDetailsRoute =
  DashboardCampaignsIdeditDetailsRouteImport.update({
    id: "/details",
    path: "/details",
    getParentRoute: () => DashboardCampaignsIdeditRouteRoute,
  } as any)
const DashboardCampaignsSetupPlanningTriggersRouteRoute =
  DashboardCampaignsSetupPlanningTriggersRouteRouteImport.update({
    id: "/triggers",
    path: "/triggers",
    getParentRoute: () => DashboardCampaignsSetupPlanningRouteRoute,
  } as any)
const DashboardCampaignsSetupDeliveryIntegrationRouteRoute =
  DashboardCampaignsSetupDeliveryIntegrationRouteRouteImport.update({
    id: "/integration",
    path: "/integration",
    getParentRoute: () => DashboardCampaignsSetupDeliveryRouteRoute,
  } as any)
const DashboardCampaignsSetupDefineAdvancedRouteRoute =
  DashboardCampaignsSetupDefineAdvancedRouteRouteImport.update({
    id: "/advanced",
    path: "/advanced",
    getParentRoute: () => DashboardCampaignsSetupDefineRouteRoute,
  } as any)
const DashboardCampaignsSetupDefineCategoryRouteRoute =
  DashboardCampaignsSetupDefineCategoryRouteRouteImport.update({
    id: "/$category",
    path: "/$category",
    getParentRoute: () => DashboardCampaignsSetupDefineRouteRoute,
  } as any)
const DashboardCampaignsIdeditStartCampaignRouteRoute =
  DashboardCampaignsIdeditStartCampaignRouteRouteImport.update({
    id: "/start-campaign",
    path: "/start-campaign",
    getParentRoute: () => DashboardCampaignsIdeditRouteRoute,
  } as any)
const DashboardCampaignsIdeditPlanningRouteRoute =
  DashboardCampaignsIdeditPlanningRouteRouteImport.update({
    id: "/planning",
    path: "/planning",
    getParentRoute: () => DashboardCampaignsIdeditRouteRoute,
  } as any)
const DashboardCampaignsIdeditDeliveryRouteRoute =
  DashboardCampaignsIdeditDeliveryRouteRouteImport.update({
    id: "/delivery",
    path: "/delivery",
    getParentRoute: () => DashboardCampaignsIdeditRouteRoute,
  } as any)
const DashboardCampaignsIdeditDefineRouteRoute =
  DashboardCampaignsIdeditDefineRouteRouteImport.update({
    id: "/define",
    path: "/define",
    getParentRoute: () => DashboardCampaignsIdeditRouteRoute,
  } as any)
const DashboardCampaignsIdeditBoostRouteRoute =
  DashboardCampaignsIdeditBoostRouteRouteImport.update({
    id: "/boost",
    path: "/boost",
    getParentRoute: () => DashboardCampaignsIdeditRouteRoute,
  } as any)
const DashboardSettingsAdminUsersUsersIndexRoute =
  DashboardSettingsAdminUsersUsersIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardSettingsAdminUsersUsersRoute,
  } as any)
const DashboardSettingsAdminUsersIdIndexRoute =
  DashboardSettingsAdminUsersIdIndexRouteImport.update({
    id: "/users/$id/",
    path: "/users/$id/",
    getParentRoute: () => DashboardSettingsAdminRouteRoute,
  } as any)
const DashboardSettingsAdminSubscriptionSubscriptionIndexRoute =
  DashboardSettingsAdminSubscriptionSubscriptionIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardSettingsAdminSubscriptionSubscriptionRoute,
  } as any)
const DashboardSettingsAdminStopListsIdIndexRoute =
  DashboardSettingsAdminStopListsIdIndexRouteImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => DashboardSettingsAdminStopListsRouteRoute,
  } as any)
const DashboardSettingsAdminDisabledInvoicesIndexRoute =
  DashboardSettingsAdminDisabledInvoicesIndexRouteImport.update({
    id: "/invoices/",
    path: "/invoices/",
    getParentRoute: () => DashboardSettingsAdminDisabledRouteRoute,
  } as any)
const DashboardCampaignsSetupPlanningTriggersIndexRoute =
  DashboardCampaignsSetupPlanningTriggersIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardCampaignsSetupPlanningTriggersRouteRoute,
  } as any)
const DashboardCampaignsSetupDefineAdvancedIndexRoute =
  DashboardCampaignsSetupDefineAdvancedIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardCampaignsSetupDefineAdvancedRouteRoute,
  } as any)
const DashboardCampaignsSetupDefineCategoryIndexRoute =
  DashboardCampaignsSetupDefineCategoryIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardCampaignsSetupDefineCategoryRouteRoute,
  } as any)
const DashboardCampaignsIdeditStartCampaignIndexRoute =
  DashboardCampaignsIdeditStartCampaignIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardCampaignsIdeditStartCampaignRouteRoute,
  } as any)
const DashboardCampaignsIdeditDeliveryIndexRoute =
  DashboardCampaignsIdeditDeliveryIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardCampaignsIdeditDeliveryRouteRoute,
  } as any)
const DashboardCampaignsIdeditDefineIndexRoute =
  DashboardCampaignsIdeditDefineIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardCampaignsIdeditDefineRouteRoute,
  } as any)
const DashboardSettingsAdminUsersUsersInviteNewRoute =
  DashboardSettingsAdminUsersUsersInviteNewRouteImport.update({
    id: "/invite-new",
    path: "/invite-new",
    getParentRoute: () => DashboardSettingsAdminUsersUsersRoute,
  } as any)
const DashboardSettingsAdminUsersUsersAddUsersRoute =
  DashboardSettingsAdminUsersUsersAddUsersRouteImport.update({
    id: "/add-users",
    path: "/add-users",
    getParentRoute: () => DashboardSettingsAdminUsersUsersRoute,
  } as any)
const DashboardSettingsAdminSubscriptionSubscriptionCreditUsageRoute =
  DashboardSettingsAdminSubscriptionSubscriptionCreditUsageRouteImport.update({
    id: "/credit-usage",
    path: "/credit-usage",
    getParentRoute: () => DashboardSettingsAdminSubscriptionSubscriptionRoute,
  } as any)
const DashboardSettingsAdminSubscriptionSubscriptionAddUsersRoute =
  DashboardSettingsAdminSubscriptionSubscriptionAddUsersRouteImport.update({
    id: "/add-users",
    path: "/add-users",
    getParentRoute: () => DashboardSettingsAdminSubscriptionSubscriptionRoute,
  } as any)
const DashboardSettingsAdminSubscriptionSubscriptionAddCreditsRoute =
  DashboardSettingsAdminSubscriptionSubscriptionAddCreditsRouteImport.update({
    id: "/add-credits",
    path: "/add-credits",
    getParentRoute: () => DashboardSettingsAdminSubscriptionSubscriptionRoute,
  } as any)
const DashboardSettingsAdminIntegrationsIntegrationSettingsRoute =
  DashboardSettingsAdminIntegrationsIntegrationSettingsRouteImport.update({
    id: "/$integration/settings",
    path: "/$integration/settings",
    getParentRoute: () => DashboardSettingsAdminIntegrationsRouteRoute,
  } as any)
const DashboardSettingsAdminIntegrationsIntegrationConnectRoute =
  DashboardSettingsAdminIntegrationsIntegrationConnectRouteImport.update({
    id: "/$integration/connect",
    path: "/$integration/connect",
    getParentRoute: () => DashboardSettingsAdminIntegrationsRouteRoute,
  } as any)
const DashboardCampaignsSetupPlanningTriggersTriggerIdRoute =
  DashboardCampaignsSetupPlanningTriggersTriggerIdRouteImport.update({
    id: "/$triggerId",
    path: "/$triggerId",
    getParentRoute: () => DashboardCampaignsSetupPlanningTriggersRouteRoute,
  } as any)
const DashboardCampaignsSetupDeliveryIntegrationMethodRoute =
  DashboardCampaignsSetupDeliveryIntegrationMethodRouteImport.update({
    id: "/method",
    path: "/method",
    getParentRoute: () => DashboardCampaignsSetupDeliveryIntegrationRouteRoute,
  } as any)
const DashboardCampaignsSetupDeliveryIntegrationConfigureRoute =
  DashboardCampaignsSetupDeliveryIntegrationConfigureRouteImport.update({
    id: "/configure",
    path: "/configure",
    getParentRoute: () => DashboardCampaignsSetupDeliveryIntegrationRouteRoute,
  } as any)
const DashboardCampaignsSetupDefineCategoryContactsRoute =
  DashboardCampaignsSetupDefineCategoryContactsRouteImport.update({
    id: "/contacts",
    path: "/contacts",
    getParentRoute: () => DashboardCampaignsSetupDefineCategoryRouteRoute,
  } as any)
const DashboardCampaignsSetupDefineCategoryFilterRoute =
  DashboardCampaignsSetupDefineCategoryFilterRouteImport.update({
    id: "/$filter",
    path: "/$filter",
    getParentRoute: () => DashboardCampaignsSetupDefineCategoryRouteRoute,
  } as any)
const DashboardCampaignsIdeditStartCampaignBuyCreditsRoute =
  DashboardCampaignsIdeditStartCampaignBuyCreditsRouteImport.update({
    id: "/buy-credits",
    path: "/buy-credits",
    getParentRoute: () => DashboardCampaignsIdeditStartCampaignRouteRoute,
  } as any)
const DashboardCampaignsIdeditPlanningSalesStrategyAndPrioritizationRoute =
  DashboardCampaignsIdeditPlanningSalesStrategyAndPrioritizationRouteImport.update(
    {
      id: "/sales-strategy-and-prioritization",
      path: "/sales-strategy-and-prioritization",
      getParentRoute: () => DashboardCampaignsIdeditPlanningRouteRoute,
    } as any,
  )
const DashboardCampaignsIdeditDeliveryBuyCreditsRoute =
  DashboardCampaignsIdeditDeliveryBuyCreditsRouteImport.update({
    id: "/buy-credits",
    path: "/buy-credits",
    getParentRoute: () => DashboardCampaignsIdeditDeliveryRouteRoute,
  } as any)
const DashboardCampaignsIdeditDefineStopListsRoute =
  DashboardCampaignsIdeditDefineStopListsRouteImport.update({
    id: "/stop-lists",
    path: "/stop-lists",
    getParentRoute: () => DashboardCampaignsIdeditDefineRouteRoute,
  } as any)
const DashboardCampaignsIdeditBoostLeadAmountRoute =
  DashboardCampaignsIdeditBoostLeadAmountRouteImport.update({
    id: "/lead-amount",
    path: "/lead-amount",
    getParentRoute: () => DashboardCampaignsIdeditBoostRouteRoute,
  } as any)
const DashboardCampaignsIdeditBoostContactInformationRoute =
  DashboardCampaignsIdeditBoostContactInformationRouteImport.update({
    id: "/contact-information",
    path: "/contact-information",
    getParentRoute: () => DashboardCampaignsIdeditBoostRouteRoute,
  } as any)
const DashboardCampaignsIdeditBoostBuyCreditsRoute =
  DashboardCampaignsIdeditBoostBuyCreditsRouteImport.update({
    id: "/buy-credits",
    path: "/buy-credits",
    getParentRoute: () => DashboardCampaignsIdeditBoostRouteRoute,
  } as any)
const DashboardCampaignsSetupDeliveryIntegrationSelectRouteRoute =
  DashboardCampaignsSetupDeliveryIntegrationSelectRouteRouteImport.update({
    id: "/select",
    path: "/select",
    getParentRoute: () => DashboardCampaignsSetupDeliveryIntegrationRouteRoute,
  } as any)
const DashboardCampaignsSetupDefineAdvancedQualityRouteRoute =
  DashboardCampaignsSetupDefineAdvancedQualityRouteRouteImport.update({
    id: "/$quality",
    path: "/$quality",
    getParentRoute: () => DashboardCampaignsSetupDefineAdvancedRouteRoute,
  } as any)
const DashboardCampaignsIdeditPlanningTriggersRouteRoute =
  DashboardCampaignsIdeditPlanningTriggersRouteRouteImport.update({
    id: "/triggers",
    path: "/triggers",
    getParentRoute: () => DashboardCampaignsIdeditPlanningRouteRoute,
  } as any)
const DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRoute =
  DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRouteImport.update({
    id: "/lead-amount-and-period",
    path: "/lead-amount-and-period",
    getParentRoute: () => DashboardCampaignsIdeditPlanningRouteRoute,
  } as any)
const DashboardCampaignsIdeditPlanningContactInformationRouteRoute =
  DashboardCampaignsIdeditPlanningContactInformationRouteRouteImport.update({
    id: "/contact-information",
    path: "/contact-information",
    getParentRoute: () => DashboardCampaignsIdeditPlanningRouteRoute,
  } as any)
const DashboardCampaignsIdeditDeliverySetupRouteRoute =
  DashboardCampaignsIdeditDeliverySetupRouteRouteImport.update({
    id: "/setup",
    path: "/setup",
    getParentRoute: () => DashboardCampaignsIdeditDeliveryRouteRoute,
  } as any)
const DashboardCampaignsIdeditDefineAdvancedRouteRoute =
  DashboardCampaignsIdeditDefineAdvancedRouteRouteImport.update({
    id: "/advanced",
    path: "/advanced",
    getParentRoute: () => DashboardCampaignsIdeditDefineRouteRoute,
  } as any)
const DashboardCampaignsIdeditDefineCategoryRouteRoute =
  DashboardCampaignsIdeditDefineCategoryRouteRouteImport.update({
    id: "/$category",
    path: "/$category",
    getParentRoute: () => DashboardCampaignsIdeditDefineRouteRoute,
  } as any)
const DashboardCampaignsIdeditAdjustWeekWeekStartRouteRoute =
  DashboardCampaignsIdeditAdjustWeekWeekStartRouteRouteImport.update({
    id: "/adjust-week/$weekStart",
    path: "/adjust-week/$weekStart",
    getParentRoute: () => DashboardCampaignsIdeditRouteRoute,
  } as any)
const DashboardSettingsAdminIntegrationsIntegrationModeIndexRoute =
  DashboardSettingsAdminIntegrationsIntegrationModeIndexRouteImport.update({
    id: "/$integration/$mode/",
    path: "/$integration/$mode/",
    getParentRoute: () => DashboardSettingsAdminIntegrationsRouteRoute,
  } as any)
const DashboardCampaignsSetupDeliveryIntegrationSelectIndexRoute =
  DashboardCampaignsSetupDeliveryIntegrationSelectIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      DashboardCampaignsSetupDeliveryIntegrationSelectRouteRoute,
  } as any)
const DashboardCampaignsIdeditPlanningTriggersIndexRoute =
  DashboardCampaignsIdeditPlanningTriggersIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardCampaignsIdeditPlanningTriggersRouteRoute,
  } as any)
const DashboardCampaignsIdeditPlanningLeadAmountAndPeriodIndexRoute =
  DashboardCampaignsIdeditPlanningLeadAmountAndPeriodIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRoute,
  } as any)
const DashboardCampaignsIdeditPlanningContactInformationIndexRoute =
  DashboardCampaignsIdeditPlanningContactInformationIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      DashboardCampaignsIdeditPlanningContactInformationRouteRoute,
  } as any)
const DashboardCampaignsIdeditDefineAdvancedIndexRoute =
  DashboardCampaignsIdeditDefineAdvancedIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardCampaignsIdeditDefineAdvancedRouteRoute,
  } as any)
const DashboardCampaignsIdeditDefineCategoryIndexRoute =
  DashboardCampaignsIdeditDefineCategoryIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardCampaignsIdeditDefineCategoryRouteRoute,
  } as any)
const DashboardCampaignsIdeditAdjustWeekWeekStartIndexRoute =
  DashboardCampaignsIdeditAdjustWeekWeekStartIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => DashboardCampaignsIdeditAdjustWeekWeekStartRouteRoute,
  } as any)
const DashboardCampaignsSetupDeliveryIntegrationSelectNewRoute =
  DashboardCampaignsSetupDeliveryIntegrationSelectNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () =>
      DashboardCampaignsSetupDeliveryIntegrationSelectRouteRoute,
  } as any)
const DashboardCampaignsIdeditPlanningTriggersTriggerIdRoute =
  DashboardCampaignsIdeditPlanningTriggersTriggerIdRouteImport.update({
    id: "/$triggerId",
    path: "/$triggerId",
    getParentRoute: () => DashboardCampaignsIdeditPlanningTriggersRouteRoute,
  } as any)
const DashboardCampaignsIdeditPlanningLeadAmountAndPeriodBuyCreditsRoute =
  DashboardCampaignsIdeditPlanningLeadAmountAndPeriodBuyCreditsRouteImport.update(
    {
      id: "/buy-credits",
      path: "/buy-credits",
      getParentRoute: () =>
        DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRoute,
    } as any,
  )
const DashboardCampaignsIdeditPlanningContactInformationBuyCreditsRoute =
  DashboardCampaignsIdeditPlanningContactInformationBuyCreditsRouteImport.update(
    {
      id: "/buy-credits",
      path: "/buy-credits",
      getParentRoute: () =>
        DashboardCampaignsIdeditPlanningContactInformationRouteRoute,
    } as any,
  )
const DashboardCampaignsIdeditDeliverySetupMethodRoute =
  DashboardCampaignsIdeditDeliverySetupMethodRouteImport.update({
    id: "/method",
    path: "/method",
    getParentRoute: () => DashboardCampaignsIdeditDeliverySetupRouteRoute,
  } as any)
const DashboardCampaignsIdeditDeliverySetupConfigureRoute =
  DashboardCampaignsIdeditDeliverySetupConfigureRouteImport.update({
    id: "/configure",
    path: "/configure",
    getParentRoute: () => DashboardCampaignsIdeditDeliverySetupRouteRoute,
  } as any)
const DashboardCampaignsIdeditDeliverySetupBuyCreditsRoute =
  DashboardCampaignsIdeditDeliverySetupBuyCreditsRouteImport.update({
    id: "/buy-credits",
    path: "/buy-credits",
    getParentRoute: () => DashboardCampaignsIdeditDeliverySetupRouteRoute,
  } as any)
const DashboardCampaignsIdeditDefineCategoryContactsRoute =
  DashboardCampaignsIdeditDefineCategoryContactsRouteImport.update({
    id: "/contacts",
    path: "/contacts",
    getParentRoute: () => DashboardCampaignsIdeditDefineCategoryRouteRoute,
  } as any)
const DashboardCampaignsIdeditDefineCategoryFilterRoute =
  DashboardCampaignsIdeditDefineCategoryFilterRouteImport.update({
    id: "/$filter",
    path: "/$filter",
    getParentRoute: () => DashboardCampaignsIdeditDefineCategoryRouteRoute,
  } as any)
const DashboardCampaignsIdeditAdjustWeekWeekStartBuyCreditsRoute =
  DashboardCampaignsIdeditAdjustWeekWeekStartBuyCreditsRouteImport.update({
    id: "/buy-credits",
    path: "/buy-credits",
    getParentRoute: () => DashboardCampaignsIdeditAdjustWeekWeekStartRouteRoute,
  } as any)
const DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRoute =
  DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRouteImport.update({
    id: "/$category",
    path: "/$category",
    getParentRoute: () =>
      DashboardCampaignsSetupDefineAdvancedQualityRouteRoute,
  } as any)
const DashboardCampaignsIdeditDeliverySetupIntegrationRouteRoute =
  DashboardCampaignsIdeditDeliverySetupIntegrationRouteRouteImport.update({
    id: "/integration",
    path: "/integration",
    getParentRoute: () => DashboardCampaignsIdeditDeliverySetupRouteRoute,
  } as any)
const DashboardCampaignsIdeditDefineAdvancedQualityRouteRoute =
  DashboardCampaignsIdeditDefineAdvancedQualityRouteRouteImport.update({
    id: "/$quality",
    path: "/$quality",
    getParentRoute: () => DashboardCampaignsIdeditDefineAdvancedRouteRoute,
  } as any)
const DashboardCampaignsSetupDefineAdvancedQualityCategoryContactsRoute =
  DashboardCampaignsSetupDefineAdvancedQualityCategoryContactsRouteImport.update(
    {
      id: "/contacts",
      path: "/contacts",
      getParentRoute: () =>
        DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRoute,
    } as any,
  )
const DashboardCampaignsSetupDefineAdvancedQualityCategoryFilterRoute =
  DashboardCampaignsSetupDefineAdvancedQualityCategoryFilterRouteImport.update({
    id: "/$filter",
    path: "/$filter",
    getParentRoute: () =>
      DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRoute,
  } as any)
const DashboardCampaignsIdeditDeliverySetupIntegrationMethodRoute =
  DashboardCampaignsIdeditDeliverySetupIntegrationMethodRouteImport.update({
    id: "/method",
    path: "/method",
    getParentRoute: () =>
      DashboardCampaignsIdeditDeliverySetupIntegrationRouteRoute,
  } as any)
const DashboardCampaignsIdeditDeliverySetupIntegrationConfigureRoute =
  DashboardCampaignsIdeditDeliverySetupIntegrationConfigureRouteImport.update({
    id: "/configure",
    path: "/configure",
    getParentRoute: () =>
      DashboardCampaignsIdeditDeliverySetupIntegrationRouteRoute,
  } as any)
const DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRoute =
  DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRouteImport.update(
    {
      id: "/select",
      path: "/select",
      getParentRoute: () =>
        DashboardCampaignsIdeditDeliverySetupIntegrationRouteRoute,
    } as any,
  )
const DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRoute =
  DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRouteImport.update({
    id: "/$category",
    path: "/$category",
    getParentRoute: () =>
      DashboardCampaignsIdeditDefineAdvancedQualityRouteRoute,
  } as any)
const DashboardCampaignsIdeditDeliverySetupIntegrationSelectIndexRoute =
  DashboardCampaignsIdeditDeliverySetupIntegrationSelectIndexRouteImport.update(
    {
      id: "/",
      path: "/",
      getParentRoute: () =>
        DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRoute,
    } as any,
  )
const DashboardCampaignsIdeditDeliverySetupIntegrationSelectNewRoute =
  DashboardCampaignsIdeditDeliverySetupIntegrationSelectNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () =>
      DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRoute,
  } as any)
const DashboardCampaignsIdeditDefineAdvancedQualityCategoryContactsRoute =
  DashboardCampaignsIdeditDefineAdvancedQualityCategoryContactsRouteImport.update(
    {
      id: "/contacts",
      path: "/contacts",
      getParentRoute: () =>
        DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRoute,
    } as any,
  )
const DashboardCampaignsIdeditDefineAdvancedQualityCategoryFilterRoute =
  DashboardCampaignsIdeditDefineAdvancedQualityCategoryFilterRouteImport.update(
    {
      id: "/$filter",
      path: "/$filter",
      getParentRoute: () =>
        DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  "/": typeof DashboardIndexRoute
  "/player": typeof PlayerRouteRouteWithChildren
  "/hidden": typeof DashboardHiddenRouteRoute
  "/leads": typeof DashboardLeadsRouteRouteWithChildren
  "/settings": typeof DashboardSettingsAdminDisabledRouteRouteWithChildren
  "/buy-credits": typeof DashboardBuyCreditsRoute
  "/intro-video": typeof DashboardIntroVideoRoute
  "/start": typeof DashboardStartRoute
  "/player/$id": typeof PlayerIdRoute
  "/campaigns/$id": typeof DashboardCampaignsIdeditRouteRouteWithChildren
  "/campaigns/setup": typeof DashboardCampaignsSetupRouteRouteWithChildren
  "/campaigns/": typeof DashboardCampaignsIndexRoute
  "/leads/": typeof DashboardLeadsIndexRoute
  "/performance/": typeof DashboardPerformanceIndexRoute
  "/settings/": typeof DashboardSettingsIndexRoute
  "/campaigns/setup/define": typeof DashboardCampaignsSetupDefineRouteRouteWithChildren
  "/campaigns/setup/delivery": typeof DashboardCampaignsSetupDeliveryRouteRouteWithChildren
  "/campaigns/setup/planning": typeof DashboardCampaignsSetupPlanningRouteRouteWithChildren
  "/settings/integrations": typeof DashboardSettingsAdminIntegrationsRouteRouteWithChildren
  "/settings/stop-lists": typeof DashboardSettingsAdminStopListsRouteRouteWithChildren
  "/settings/profile": typeof DashboardSettingsProfileProfileRouteWithChildren
  "/campaigns/$id/": typeof DashboardCampaignsIdIndexRoute
  "/campaigns/$id/boost": typeof DashboardCampaignsIdeditBoostRouteRouteWithChildren
  "/campaigns/$id/define": typeof DashboardCampaignsIdeditDefineRouteRouteWithChildren
  "/campaigns/$id/delivery": typeof DashboardCampaignsIdeditDeliveryRouteRouteWithChildren
  "/campaigns/$id/planning": typeof DashboardCampaignsIdeditPlanningRouteRouteWithChildren
  "/campaigns/$id/start-campaign": typeof DashboardCampaignsIdeditStartCampaignRouteRouteWithChildren
  "/campaigns/setup/define/$category": typeof DashboardCampaignsSetupDefineCategoryRouteRouteWithChildren
  "/campaigns/setup/define/advanced": typeof DashboardCampaignsSetupDefineAdvancedRouteRouteWithChildren
  "/campaigns/setup/delivery/integration": typeof DashboardCampaignsSetupDeliveryIntegrationRouteRouteWithChildren
  "/campaigns/setup/planning/triggers": typeof DashboardCampaignsSetupPlanningTriggersRouteRouteWithChildren
  "/campaigns/$id/details": typeof DashboardCampaignsIdeditDetailsRoute
  "/campaigns/setup/define/stop-lists": typeof DashboardCampaignsSetupDefineStopListsRoute
  "/campaigns/setup/delivery/configure": typeof DashboardCampaignsSetupDeliveryConfigureRoute
  "/campaigns/setup/delivery/method": typeof DashboardCampaignsSetupDeliveryMethodRoute
  "/campaigns/setup/planning/contact-information": typeof DashboardCampaignsSetupPlanningContactInformationRoute
  "/campaigns/setup/planning/lead-amount": typeof DashboardCampaignsSetupPlanningLeadAmountRoute
  "/campaigns/setup/planning/lead-amount-and-period": typeof DashboardCampaignsSetupPlanningLeadAmountAndPeriodRoute
  "/campaigns/setup/planning/sales-strategy-and-prioritization": typeof DashboardCampaignsSetupPlanningSalesStrategyAndPrioritizationRoute
  "/campaigns/setup/planning/type": typeof DashboardCampaignsSetupPlanningTypeRoute
  "/campaigns/setup/summary/buy-credits": typeof DashboardCampaignsSetupSummaryBuyCreditsRoute
  "/settings/subscription": typeof DashboardSettingsAdminSubscriptionSubscriptionRouteWithChildren
  "/settings/users": typeof DashboardSettingsAdminUsersUsersRouteWithChildren
  "/campaigns/setup/define/": typeof DashboardCampaignsSetupDefineIndexRoute
  "/campaigns/setup/details/": typeof DashboardCampaignsSetupDetailsIndexRoute
  "/campaigns/setup/summary/": typeof DashboardCampaignsSetupSummaryIndexRoute
  "/settings/company/": typeof DashboardSettingsAdminCompanyIndexRoute
  "/settings/integrations/": typeof DashboardSettingsAdminIntegrationsIndexRoute
  "/settings/stop-lists/": typeof DashboardSettingsAdminStopListsIndexRoute
  "/settings/profile/": typeof DashboardSettingsProfileProfileIndexRoute
  "/campaigns/$id/adjust-week/$weekStart": typeof DashboardCampaignsIdeditAdjustWeekWeekStartRouteRouteWithChildren
  "/campaigns/$id/define/$category": typeof DashboardCampaignsIdeditDefineCategoryRouteRouteWithChildren
  "/campaigns/$id/define/advanced": typeof DashboardCampaignsIdeditDefineAdvancedRouteRouteWithChildren
  "/campaigns/$id/delivery/setup": typeof DashboardCampaignsIdeditDeliverySetupRouteRouteWithChildren
  "/campaigns/$id/planning/contact-information": typeof DashboardCampaignsIdeditPlanningContactInformationRouteRouteWithChildren
  "/campaigns/$id/planning/lead-amount-and-period": typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRouteWithChildren
  "/campaigns/$id/planning/triggers": typeof DashboardCampaignsIdeditPlanningTriggersRouteRouteWithChildren
  "/campaigns/setup/define/advanced/$quality": typeof DashboardCampaignsSetupDefineAdvancedQualityRouteRouteWithChildren
  "/campaigns/setup/delivery/integration/select": typeof DashboardCampaignsSetupDeliveryIntegrationSelectRouteRouteWithChildren
  "/campaigns/$id/boost/buy-credits": typeof DashboardCampaignsIdeditBoostBuyCreditsRoute
  "/campaigns/$id/boost/contact-information": typeof DashboardCampaignsIdeditBoostContactInformationRoute
  "/campaigns/$id/boost/lead-amount": typeof DashboardCampaignsIdeditBoostLeadAmountRoute
  "/campaigns/$id/define/stop-lists": typeof DashboardCampaignsIdeditDefineStopListsRoute
  "/campaigns/$id/delivery/buy-credits": typeof DashboardCampaignsIdeditDeliveryBuyCreditsRoute
  "/campaigns/$id/planning/sales-strategy-and-prioritization": typeof DashboardCampaignsIdeditPlanningSalesStrategyAndPrioritizationRoute
  "/campaigns/$id/start-campaign/buy-credits": typeof DashboardCampaignsIdeditStartCampaignBuyCreditsRoute
  "/campaigns/setup/define/$category/$filter": typeof DashboardCampaignsSetupDefineCategoryFilterRoute
  "/campaigns/setup/define/$category/contacts": typeof DashboardCampaignsSetupDefineCategoryContactsRoute
  "/campaigns/setup/delivery/integration/configure": typeof DashboardCampaignsSetupDeliveryIntegrationConfigureRoute
  "/campaigns/setup/delivery/integration/method": typeof DashboardCampaignsSetupDeliveryIntegrationMethodRoute
  "/campaigns/setup/planning/triggers/$triggerId": typeof DashboardCampaignsSetupPlanningTriggersTriggerIdRoute
  "/settings/integrations/$integration/connect": typeof DashboardSettingsAdminIntegrationsIntegrationConnectRoute
  "/settings/integrations/$integration/settings": typeof DashboardSettingsAdminIntegrationsIntegrationSettingsRoute
  "/settings/subscription/add-credits": typeof DashboardSettingsAdminSubscriptionSubscriptionAddCreditsRoute
  "/settings/subscription/add-users": typeof DashboardSettingsAdminSubscriptionSubscriptionAddUsersRoute
  "/settings/subscription/credit-usage": typeof DashboardSettingsAdminSubscriptionSubscriptionCreditUsageRoute
  "/settings/users/add-users": typeof DashboardSettingsAdminUsersUsersAddUsersRoute
  "/settings/users/invite-new": typeof DashboardSettingsAdminUsersUsersInviteNewRoute
  "/campaigns/$id/define/": typeof DashboardCampaignsIdeditDefineIndexRoute
  "/campaigns/$id/delivery/": typeof DashboardCampaignsIdeditDeliveryIndexRoute
  "/campaigns/$id/start-campaign/": typeof DashboardCampaignsIdeditStartCampaignIndexRoute
  "/campaigns/setup/define/$category/": typeof DashboardCampaignsSetupDefineCategoryIndexRoute
  "/campaigns/setup/define/advanced/": typeof DashboardCampaignsSetupDefineAdvancedIndexRoute
  "/campaigns/setup/planning/triggers/": typeof DashboardCampaignsSetupPlanningTriggersIndexRoute
  "/settings/invoices/": typeof DashboardSettingsAdminDisabledInvoicesIndexRoute
  "/settings/stop-lists/$id/": typeof DashboardSettingsAdminStopListsIdIndexRoute
  "/settings/subscription/": typeof DashboardSettingsAdminSubscriptionSubscriptionIndexRoute
  "/settings/users/$id/": typeof DashboardSettingsAdminUsersIdIndexRoute
  "/settings/users/": typeof DashboardSettingsAdminUsersUsersIndexRoute
  "/campaigns/$id/define/advanced/$quality": typeof DashboardCampaignsIdeditDefineAdvancedQualityRouteRouteWithChildren
  "/campaigns/$id/delivery/setup/integration": typeof DashboardCampaignsIdeditDeliverySetupIntegrationRouteRouteWithChildren
  "/campaigns/setup/define/advanced/$quality/$category": typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRouteWithChildren
  "/campaigns/$id/adjust-week/$weekStart/buy-credits": typeof DashboardCampaignsIdeditAdjustWeekWeekStartBuyCreditsRoute
  "/campaigns/$id/define/$category/$filter": typeof DashboardCampaignsIdeditDefineCategoryFilterRoute
  "/campaigns/$id/define/$category/contacts": typeof DashboardCampaignsIdeditDefineCategoryContactsRoute
  "/campaigns/$id/delivery/setup/buy-credits": typeof DashboardCampaignsIdeditDeliverySetupBuyCreditsRoute
  "/campaigns/$id/delivery/setup/configure": typeof DashboardCampaignsIdeditDeliverySetupConfigureRoute
  "/campaigns/$id/delivery/setup/method": typeof DashboardCampaignsIdeditDeliverySetupMethodRoute
  "/campaigns/$id/planning/contact-information/buy-credits": typeof DashboardCampaignsIdeditPlanningContactInformationBuyCreditsRoute
  "/campaigns/$id/planning/lead-amount-and-period/buy-credits": typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodBuyCreditsRoute
  "/campaigns/$id/planning/triggers/$triggerId": typeof DashboardCampaignsIdeditPlanningTriggersTriggerIdRoute
  "/campaigns/setup/delivery/integration/select/new": typeof DashboardCampaignsSetupDeliveryIntegrationSelectNewRoute
  "/campaigns/$id/adjust-week/$weekStart/": typeof DashboardCampaignsIdeditAdjustWeekWeekStartIndexRoute
  "/campaigns/$id/define/$category/": typeof DashboardCampaignsIdeditDefineCategoryIndexRoute
  "/campaigns/$id/define/advanced/": typeof DashboardCampaignsIdeditDefineAdvancedIndexRoute
  "/campaigns/$id/planning/contact-information/": typeof DashboardCampaignsIdeditPlanningContactInformationIndexRoute
  "/campaigns/$id/planning/lead-amount-and-period/": typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodIndexRoute
  "/campaigns/$id/planning/triggers/": typeof DashboardCampaignsIdeditPlanningTriggersIndexRoute
  "/campaigns/setup/delivery/integration/select/": typeof DashboardCampaignsSetupDeliveryIntegrationSelectIndexRoute
  "/settings/integrations/$integration/$mode/": typeof DashboardSettingsAdminIntegrationsIntegrationModeIndexRoute
  "/campaigns/$id/define/advanced/$quality/$category": typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRouteWithChildren
  "/campaigns/$id/delivery/setup/integration/select": typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRouteWithChildren
  "/campaigns/$id/delivery/setup/integration/configure": typeof DashboardCampaignsIdeditDeliverySetupIntegrationConfigureRoute
  "/campaigns/$id/delivery/setup/integration/method": typeof DashboardCampaignsIdeditDeliverySetupIntegrationMethodRoute
  "/campaigns/setup/define/advanced/$quality/$category/$filter": typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryFilterRoute
  "/campaigns/setup/define/advanced/$quality/$category/contacts": typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryContactsRoute
  "/campaigns/$id/define/advanced/$quality/$category/$filter": typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryFilterRoute
  "/campaigns/$id/define/advanced/$quality/$category/contacts": typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryContactsRoute
  "/campaigns/$id/delivery/setup/integration/select/new": typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectNewRoute
  "/campaigns/$id/delivery/setup/integration/select/": typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectIndexRoute
}
export interface FileRoutesByTo {
  "/player": typeof PlayerRouteRouteWithChildren
  "/hidden": typeof DashboardHiddenRouteRoute
  "/buy-credits": typeof DashboardBuyCreditsRoute
  "/intro-video": typeof DashboardIntroVideoRoute
  "/start": typeof DashboardStartRoute
  "/player/$id": typeof PlayerIdRoute
  "/": typeof DashboardIndexRoute
  "/campaigns/setup": typeof DashboardCampaignsSetupRouteRouteWithChildren
  "/settings": typeof DashboardSettingsAdminDisabledRouteRouteWithChildren
  "/campaigns": typeof DashboardCampaignsIndexRoute
  "/leads": typeof DashboardLeadsIndexRoute
  "/performance": typeof DashboardPerformanceIndexRoute
  "/campaigns/$id": typeof DashboardCampaignsIdIndexRoute
  "/campaigns/setup/delivery": typeof DashboardCampaignsSetupDeliveryRouteRouteWithChildren
  "/campaigns/setup/planning": typeof DashboardCampaignsSetupPlanningRouteRouteWithChildren
  "/campaigns/$id/boost": typeof DashboardCampaignsIdeditBoostRouteRouteWithChildren
  "/campaigns/$id/planning": typeof DashboardCampaignsIdeditPlanningRouteRouteWithChildren
  "/campaigns/setup/delivery/integration": typeof DashboardCampaignsSetupDeliveryIntegrationRouteRouteWithChildren
  "/campaigns/$id/details": typeof DashboardCampaignsIdeditDetailsRoute
  "/campaigns/setup/define/stop-lists": typeof DashboardCampaignsSetupDefineStopListsRoute
  "/campaigns/setup/delivery/configure": typeof DashboardCampaignsSetupDeliveryConfigureRoute
  "/campaigns/setup/delivery/method": typeof DashboardCampaignsSetupDeliveryMethodRoute
  "/campaigns/setup/planning/contact-information": typeof DashboardCampaignsSetupPlanningContactInformationRoute
  "/campaigns/setup/planning/lead-amount": typeof DashboardCampaignsSetupPlanningLeadAmountRoute
  "/campaigns/setup/planning/lead-amount-and-period": typeof DashboardCampaignsSetupPlanningLeadAmountAndPeriodRoute
  "/campaigns/setup/planning/sales-strategy-and-prioritization": typeof DashboardCampaignsSetupPlanningSalesStrategyAndPrioritizationRoute
  "/campaigns/setup/planning/type": typeof DashboardCampaignsSetupPlanningTypeRoute
  "/campaigns/setup/summary/buy-credits": typeof DashboardCampaignsSetupSummaryBuyCreditsRoute
  "/campaigns/setup/define": typeof DashboardCampaignsSetupDefineIndexRoute
  "/campaigns/setup/details": typeof DashboardCampaignsSetupDetailsIndexRoute
  "/campaigns/setup/summary": typeof DashboardCampaignsSetupSummaryIndexRoute
  "/settings/company": typeof DashboardSettingsAdminCompanyIndexRoute
  "/settings/integrations": typeof DashboardSettingsAdminIntegrationsIndexRoute
  "/settings/stop-lists": typeof DashboardSettingsAdminStopListsIndexRoute
  "/settings/profile": typeof DashboardSettingsProfileProfileIndexRoute
  "/campaigns/$id/delivery/setup": typeof DashboardCampaignsIdeditDeliverySetupRouteRouteWithChildren
  "/campaigns/setup/define/advanced/$quality": typeof DashboardCampaignsSetupDefineAdvancedQualityRouteRouteWithChildren
  "/campaigns/$id/boost/buy-credits": typeof DashboardCampaignsIdeditBoostBuyCreditsRoute
  "/campaigns/$id/boost/contact-information": typeof DashboardCampaignsIdeditBoostContactInformationRoute
  "/campaigns/$id/boost/lead-amount": typeof DashboardCampaignsIdeditBoostLeadAmountRoute
  "/campaigns/$id/define/stop-lists": typeof DashboardCampaignsIdeditDefineStopListsRoute
  "/campaigns/$id/delivery/buy-credits": typeof DashboardCampaignsIdeditDeliveryBuyCreditsRoute
  "/campaigns/$id/planning/sales-strategy-and-prioritization": typeof DashboardCampaignsIdeditPlanningSalesStrategyAndPrioritizationRoute
  "/campaigns/$id/start-campaign/buy-credits": typeof DashboardCampaignsIdeditStartCampaignBuyCreditsRoute
  "/campaigns/setup/define/$category/$filter": typeof DashboardCampaignsSetupDefineCategoryFilterRoute
  "/campaigns/setup/define/$category/contacts": typeof DashboardCampaignsSetupDefineCategoryContactsRoute
  "/campaigns/setup/delivery/integration/configure": typeof DashboardCampaignsSetupDeliveryIntegrationConfigureRoute
  "/campaigns/setup/delivery/integration/method": typeof DashboardCampaignsSetupDeliveryIntegrationMethodRoute
  "/campaigns/setup/planning/triggers/$triggerId": typeof DashboardCampaignsSetupPlanningTriggersTriggerIdRoute
  "/settings/integrations/$integration/connect": typeof DashboardSettingsAdminIntegrationsIntegrationConnectRoute
  "/settings/integrations/$integration/settings": typeof DashboardSettingsAdminIntegrationsIntegrationSettingsRoute
  "/settings/subscription/add-credits": typeof DashboardSettingsAdminSubscriptionSubscriptionAddCreditsRoute
  "/settings/subscription/add-users": typeof DashboardSettingsAdminSubscriptionSubscriptionAddUsersRoute
  "/settings/subscription/credit-usage": typeof DashboardSettingsAdminSubscriptionSubscriptionCreditUsageRoute
  "/settings/users/add-users": typeof DashboardSettingsAdminUsersUsersAddUsersRoute
  "/settings/users/invite-new": typeof DashboardSettingsAdminUsersUsersInviteNewRoute
  "/campaigns/$id/define": typeof DashboardCampaignsIdeditDefineIndexRoute
  "/campaigns/$id/delivery": typeof DashboardCampaignsIdeditDeliveryIndexRoute
  "/campaigns/$id/start-campaign": typeof DashboardCampaignsIdeditStartCampaignIndexRoute
  "/campaigns/setup/define/$category": typeof DashboardCampaignsSetupDefineCategoryIndexRoute
  "/campaigns/setup/define/advanced": typeof DashboardCampaignsSetupDefineAdvancedIndexRoute
  "/campaigns/setup/planning/triggers": typeof DashboardCampaignsSetupPlanningTriggersIndexRoute
  "/settings/invoices": typeof DashboardSettingsAdminDisabledInvoicesIndexRoute
  "/settings/stop-lists/$id": typeof DashboardSettingsAdminStopListsIdIndexRoute
  "/settings/subscription": typeof DashboardSettingsAdminSubscriptionSubscriptionIndexRoute
  "/settings/users/$id": typeof DashboardSettingsAdminUsersIdIndexRoute
  "/settings/users": typeof DashboardSettingsAdminUsersUsersIndexRoute
  "/campaigns/$id/define/advanced/$quality": typeof DashboardCampaignsIdeditDefineAdvancedQualityRouteRouteWithChildren
  "/campaigns/$id/delivery/setup/integration": typeof DashboardCampaignsIdeditDeliverySetupIntegrationRouteRouteWithChildren
  "/campaigns/setup/define/advanced/$quality/$category": typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRouteWithChildren
  "/campaigns/$id/adjust-week/$weekStart/buy-credits": typeof DashboardCampaignsIdeditAdjustWeekWeekStartBuyCreditsRoute
  "/campaigns/$id/define/$category/$filter": typeof DashboardCampaignsIdeditDefineCategoryFilterRoute
  "/campaigns/$id/define/$category/contacts": typeof DashboardCampaignsIdeditDefineCategoryContactsRoute
  "/campaigns/$id/delivery/setup/buy-credits": typeof DashboardCampaignsIdeditDeliverySetupBuyCreditsRoute
  "/campaigns/$id/delivery/setup/configure": typeof DashboardCampaignsIdeditDeliverySetupConfigureRoute
  "/campaigns/$id/delivery/setup/method": typeof DashboardCampaignsIdeditDeliverySetupMethodRoute
  "/campaigns/$id/planning/contact-information/buy-credits": typeof DashboardCampaignsIdeditPlanningContactInformationBuyCreditsRoute
  "/campaigns/$id/planning/lead-amount-and-period/buy-credits": typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodBuyCreditsRoute
  "/campaigns/$id/planning/triggers/$triggerId": typeof DashboardCampaignsIdeditPlanningTriggersTriggerIdRoute
  "/campaigns/setup/delivery/integration/select/new": typeof DashboardCampaignsSetupDeliveryIntegrationSelectNewRoute
  "/campaigns/$id/adjust-week/$weekStart": typeof DashboardCampaignsIdeditAdjustWeekWeekStartIndexRoute
  "/campaigns/$id/define/$category": typeof DashboardCampaignsIdeditDefineCategoryIndexRoute
  "/campaigns/$id/define/advanced": typeof DashboardCampaignsIdeditDefineAdvancedIndexRoute
  "/campaigns/$id/planning/contact-information": typeof DashboardCampaignsIdeditPlanningContactInformationIndexRoute
  "/campaigns/$id/planning/lead-amount-and-period": typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodIndexRoute
  "/campaigns/$id/planning/triggers": typeof DashboardCampaignsIdeditPlanningTriggersIndexRoute
  "/campaigns/setup/delivery/integration/select": typeof DashboardCampaignsSetupDeliveryIntegrationSelectIndexRoute
  "/settings/integrations/$integration/$mode": typeof DashboardSettingsAdminIntegrationsIntegrationModeIndexRoute
  "/campaigns/$id/define/advanced/$quality/$category": typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRouteWithChildren
  "/campaigns/$id/delivery/setup/integration/configure": typeof DashboardCampaignsIdeditDeliverySetupIntegrationConfigureRoute
  "/campaigns/$id/delivery/setup/integration/method": typeof DashboardCampaignsIdeditDeliverySetupIntegrationMethodRoute
  "/campaigns/setup/define/advanced/$quality/$category/$filter": typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryFilterRoute
  "/campaigns/setup/define/advanced/$quality/$category/contacts": typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryContactsRoute
  "/campaigns/$id/define/advanced/$quality/$category/$filter": typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryFilterRoute
  "/campaigns/$id/define/advanced/$quality/$category/contacts": typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryContactsRoute
  "/campaigns/$id/delivery/setup/integration/select/new": typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectNewRoute
  "/campaigns/$id/delivery/setup/integration/select": typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_dashboard": typeof DashboardRouteRouteWithChildren
  "/player": typeof PlayerRouteRouteWithChildren
  "/_dashboard/hidden": typeof DashboardHiddenRouteRoute
  "/_dashboard/leads": typeof DashboardLeadsRouteRouteWithChildren
  "/_dashboard/settings": typeof DashboardSettingsRouteRouteWithChildren
  "/_dashboard/buy-credits": typeof DashboardBuyCreditsRoute
  "/_dashboard/intro-video": typeof DashboardIntroVideoRoute
  "/_dashboard/start": typeof DashboardStartRoute
  "/player/$id": typeof PlayerIdRoute
  "/_dashboard/": typeof DashboardIndexRoute
  "/_dashboard/campaigns/$id": typeof DashboardCampaignsIdRouteRouteWithChildren
  "/_dashboard/campaigns/setup": typeof DashboardCampaignsSetupRouteRouteWithChildren
  "/_dashboard/settings/_admin": typeof DashboardSettingsAdminRouteRouteWithChildren
  "/_dashboard/campaigns/": typeof DashboardCampaignsIndexRoute
  "/_dashboard/leads/": typeof DashboardLeadsIndexRoute
  "/_dashboard/performance/": typeof DashboardPerformanceIndexRoute
  "/_dashboard/settings/": typeof DashboardSettingsIndexRoute
  "/_dashboard/campaigns/$id/(edit)": typeof DashboardCampaignsIdeditRouteRouteWithChildren
  "/_dashboard/campaigns/setup/define": typeof DashboardCampaignsSetupDefineRouteRouteWithChildren
  "/_dashboard/campaigns/setup/delivery": typeof DashboardCampaignsSetupDeliveryRouteRouteWithChildren
  "/_dashboard/campaigns/setup/planning": typeof DashboardCampaignsSetupPlanningRouteRouteWithChildren
  "/_dashboard/settings/_admin/_disabled": typeof DashboardSettingsAdminDisabledRouteRouteWithChildren
  "/_dashboard/settings/_admin/integrations": typeof DashboardSettingsAdminIntegrationsRouteRouteWithChildren
  "/_dashboard/settings/_admin/stop-lists": typeof DashboardSettingsAdminStopListsRouteRouteWithChildren
  "/_dashboard/settings/profile/_profile": typeof DashboardSettingsProfileProfileRouteWithChildren
  "/_dashboard/campaigns/$id/": typeof DashboardCampaignsIdIndexRoute
  "/_dashboard/campaigns/$id/(edit)/boost": typeof DashboardCampaignsIdeditBoostRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/define": typeof DashboardCampaignsIdeditDefineRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/delivery": typeof DashboardCampaignsIdeditDeliveryRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/planning": typeof DashboardCampaignsIdeditPlanningRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/start-campaign": typeof DashboardCampaignsIdeditStartCampaignRouteRouteWithChildren
  "/_dashboard/campaigns/setup/define/$category": typeof DashboardCampaignsSetupDefineCategoryRouteRouteWithChildren
  "/_dashboard/campaigns/setup/define/advanced": typeof DashboardCampaignsSetupDefineAdvancedRouteRouteWithChildren
  "/_dashboard/campaigns/setup/delivery/integration": typeof DashboardCampaignsSetupDeliveryIntegrationRouteRouteWithChildren
  "/_dashboard/campaigns/setup/planning/triggers": typeof DashboardCampaignsSetupPlanningTriggersRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/details": typeof DashboardCampaignsIdeditDetailsRoute
  "/_dashboard/campaigns/setup/define/stop-lists": typeof DashboardCampaignsSetupDefineStopListsRoute
  "/_dashboard/campaigns/setup/delivery/configure": typeof DashboardCampaignsSetupDeliveryConfigureRoute
  "/_dashboard/campaigns/setup/delivery/method": typeof DashboardCampaignsSetupDeliveryMethodRoute
  "/_dashboard/campaigns/setup/planning/contact-information": typeof DashboardCampaignsSetupPlanningContactInformationRoute
  "/_dashboard/campaigns/setup/planning/lead-amount": typeof DashboardCampaignsSetupPlanningLeadAmountRoute
  "/_dashboard/campaigns/setup/planning/lead-amount-and-period": typeof DashboardCampaignsSetupPlanningLeadAmountAndPeriodRoute
  "/_dashboard/campaigns/setup/planning/sales-strategy-and-prioritization": typeof DashboardCampaignsSetupPlanningSalesStrategyAndPrioritizationRoute
  "/_dashboard/campaigns/setup/planning/type": typeof DashboardCampaignsSetupPlanningTypeRoute
  "/_dashboard/campaigns/setup/summary/buy-credits": typeof DashboardCampaignsSetupSummaryBuyCreditsRoute
  "/_dashboard/settings/_admin/subscription/_subscription": typeof DashboardSettingsAdminSubscriptionSubscriptionRouteWithChildren
  "/_dashboard/settings/_admin/users/_users": typeof DashboardSettingsAdminUsersUsersRouteWithChildren
  "/_dashboard/campaigns/setup/define/": typeof DashboardCampaignsSetupDefineIndexRoute
  "/_dashboard/campaigns/setup/details/": typeof DashboardCampaignsSetupDetailsIndexRoute
  "/_dashboard/campaigns/setup/summary/": typeof DashboardCampaignsSetupSummaryIndexRoute
  "/_dashboard/settings/_admin/company/": typeof DashboardSettingsAdminCompanyIndexRoute
  "/_dashboard/settings/_admin/integrations/": typeof DashboardSettingsAdminIntegrationsIndexRoute
  "/_dashboard/settings/_admin/stop-lists/": typeof DashboardSettingsAdminStopListsIndexRoute
  "/_dashboard/settings/profile/_profile/": typeof DashboardSettingsProfileProfileIndexRoute
  "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart": typeof DashboardCampaignsIdeditAdjustWeekWeekStartRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/define/$category": typeof DashboardCampaignsIdeditDefineCategoryRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/define/advanced": typeof DashboardCampaignsIdeditDefineAdvancedRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/delivery/setup": typeof DashboardCampaignsIdeditDeliverySetupRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/planning/contact-information": typeof DashboardCampaignsIdeditPlanningContactInformationRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period": typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/planning/triggers": typeof DashboardCampaignsIdeditPlanningTriggersRouteRouteWithChildren
  "/_dashboard/campaigns/setup/define/advanced/$quality": typeof DashboardCampaignsSetupDefineAdvancedQualityRouteRouteWithChildren
  "/_dashboard/campaigns/setup/delivery/integration/select": typeof DashboardCampaignsSetupDeliveryIntegrationSelectRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/boost/buy-credits": typeof DashboardCampaignsIdeditBoostBuyCreditsRoute
  "/_dashboard/campaigns/$id/(edit)/boost/contact-information": typeof DashboardCampaignsIdeditBoostContactInformationRoute
  "/_dashboard/campaigns/$id/(edit)/boost/lead-amount": typeof DashboardCampaignsIdeditBoostLeadAmountRoute
  "/_dashboard/campaigns/$id/(edit)/define/stop-lists": typeof DashboardCampaignsIdeditDefineStopListsRoute
  "/_dashboard/campaigns/$id/(edit)/delivery/buy-credits": typeof DashboardCampaignsIdeditDeliveryBuyCreditsRoute
  "/_dashboard/campaigns/$id/(edit)/planning/sales-strategy-and-prioritization": typeof DashboardCampaignsIdeditPlanningSalesStrategyAndPrioritizationRoute
  "/_dashboard/campaigns/$id/(edit)/start-campaign/buy-credits": typeof DashboardCampaignsIdeditStartCampaignBuyCreditsRoute
  "/_dashboard/campaigns/setup/define/$category/$filter": typeof DashboardCampaignsSetupDefineCategoryFilterRoute
  "/_dashboard/campaigns/setup/define/$category/contacts": typeof DashboardCampaignsSetupDefineCategoryContactsRoute
  "/_dashboard/campaigns/setup/delivery/integration/configure": typeof DashboardCampaignsSetupDeliveryIntegrationConfigureRoute
  "/_dashboard/campaigns/setup/delivery/integration/method": typeof DashboardCampaignsSetupDeliveryIntegrationMethodRoute
  "/_dashboard/campaigns/setup/planning/triggers/$triggerId": typeof DashboardCampaignsSetupPlanningTriggersTriggerIdRoute
  "/_dashboard/settings/_admin/integrations/$integration/connect": typeof DashboardSettingsAdminIntegrationsIntegrationConnectRoute
  "/_dashboard/settings/_admin/integrations/$integration/settings": typeof DashboardSettingsAdminIntegrationsIntegrationSettingsRoute
  "/_dashboard/settings/_admin/subscription/_subscription/add-credits": typeof DashboardSettingsAdminSubscriptionSubscriptionAddCreditsRoute
  "/_dashboard/settings/_admin/subscription/_subscription/add-users": typeof DashboardSettingsAdminSubscriptionSubscriptionAddUsersRoute
  "/_dashboard/settings/_admin/subscription/_subscription/credit-usage": typeof DashboardSettingsAdminSubscriptionSubscriptionCreditUsageRoute
  "/_dashboard/settings/_admin/users/_users/add-users": typeof DashboardSettingsAdminUsersUsersAddUsersRoute
  "/_dashboard/settings/_admin/users/_users/invite-new": typeof DashboardSettingsAdminUsersUsersInviteNewRoute
  "/_dashboard/campaigns/$id/(edit)/define/": typeof DashboardCampaignsIdeditDefineIndexRoute
  "/_dashboard/campaigns/$id/(edit)/delivery/": typeof DashboardCampaignsIdeditDeliveryIndexRoute
  "/_dashboard/campaigns/$id/(edit)/start-campaign/": typeof DashboardCampaignsIdeditStartCampaignIndexRoute
  "/_dashboard/campaigns/setup/define/$category/": typeof DashboardCampaignsSetupDefineCategoryIndexRoute
  "/_dashboard/campaigns/setup/define/advanced/": typeof DashboardCampaignsSetupDefineAdvancedIndexRoute
  "/_dashboard/campaigns/setup/planning/triggers/": typeof DashboardCampaignsSetupPlanningTriggersIndexRoute
  "/_dashboard/settings/_admin/_disabled/invoices/": typeof DashboardSettingsAdminDisabledInvoicesIndexRoute
  "/_dashboard/settings/_admin/stop-lists/$id/": typeof DashboardSettingsAdminStopListsIdIndexRoute
  "/_dashboard/settings/_admin/subscription/_subscription/": typeof DashboardSettingsAdminSubscriptionSubscriptionIndexRoute
  "/_dashboard/settings/_admin/users/$id/": typeof DashboardSettingsAdminUsersIdIndexRoute
  "/_dashboard/settings/_admin/users/_users/": typeof DashboardSettingsAdminUsersUsersIndexRoute
  "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality": typeof DashboardCampaignsIdeditDefineAdvancedQualityRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration": typeof DashboardCampaignsIdeditDeliverySetupIntegrationRouteRouteWithChildren
  "/_dashboard/campaigns/setup/define/advanced/$quality/$category": typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart/buy-credits": typeof DashboardCampaignsIdeditAdjustWeekWeekStartBuyCreditsRoute
  "/_dashboard/campaigns/$id/(edit)/define/$category/$filter": typeof DashboardCampaignsIdeditDefineCategoryFilterRoute
  "/_dashboard/campaigns/$id/(edit)/define/$category/contacts": typeof DashboardCampaignsIdeditDefineCategoryContactsRoute
  "/_dashboard/campaigns/$id/(edit)/delivery/setup/buy-credits": typeof DashboardCampaignsIdeditDeliverySetupBuyCreditsRoute
  "/_dashboard/campaigns/$id/(edit)/delivery/setup/configure": typeof DashboardCampaignsIdeditDeliverySetupConfigureRoute
  "/_dashboard/campaigns/$id/(edit)/delivery/setup/method": typeof DashboardCampaignsIdeditDeliverySetupMethodRoute
  "/_dashboard/campaigns/$id/(edit)/planning/contact-information/buy-credits": typeof DashboardCampaignsIdeditPlanningContactInformationBuyCreditsRoute
  "/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period/buy-credits": typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodBuyCreditsRoute
  "/_dashboard/campaigns/$id/(edit)/planning/triggers/$triggerId": typeof DashboardCampaignsIdeditPlanningTriggersTriggerIdRoute
  "/_dashboard/campaigns/setup/delivery/integration/select/new": typeof DashboardCampaignsSetupDeliveryIntegrationSelectNewRoute
  "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart/": typeof DashboardCampaignsIdeditAdjustWeekWeekStartIndexRoute
  "/_dashboard/campaigns/$id/(edit)/define/$category/": typeof DashboardCampaignsIdeditDefineCategoryIndexRoute
  "/_dashboard/campaigns/$id/(edit)/define/advanced/": typeof DashboardCampaignsIdeditDefineAdvancedIndexRoute
  "/_dashboard/campaigns/$id/(edit)/planning/contact-information/": typeof DashboardCampaignsIdeditPlanningContactInformationIndexRoute
  "/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period/": typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodIndexRoute
  "/_dashboard/campaigns/$id/(edit)/planning/triggers/": typeof DashboardCampaignsIdeditPlanningTriggersIndexRoute
  "/_dashboard/campaigns/setup/delivery/integration/select/": typeof DashboardCampaignsSetupDeliveryIntegrationSelectIndexRoute
  "/_dashboard/settings/_admin/integrations/$integration/$mode/": typeof DashboardSettingsAdminIntegrationsIntegrationModeIndexRoute
  "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category": typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select": typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRouteWithChildren
  "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/configure": typeof DashboardCampaignsIdeditDeliverySetupIntegrationConfigureRoute
  "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/method": typeof DashboardCampaignsIdeditDeliverySetupIntegrationMethodRoute
  "/_dashboard/campaigns/setup/define/advanced/$quality/$category/$filter": typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryFilterRoute
  "/_dashboard/campaigns/setup/define/advanced/$quality/$category/contacts": typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryContactsRoute
  "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category/$filter": typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryFilterRoute
  "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category/contacts": typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryContactsRoute
  "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select/new": typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectNewRoute
  "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select/": typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/player"
    | "/hidden"
    | "/leads"
    | "/settings"
    | "/buy-credits"
    | "/intro-video"
    | "/start"
    | "/player/$id"
    | "/campaigns/$id"
    | "/campaigns/setup"
    | "/campaigns/"
    | "/leads/"
    | "/performance/"
    | "/settings/"
    | "/campaigns/setup/define"
    | "/campaigns/setup/delivery"
    | "/campaigns/setup/planning"
    | "/settings/integrations"
    | "/settings/stop-lists"
    | "/settings/profile"
    | "/campaigns/$id/"
    | "/campaigns/$id/boost"
    | "/campaigns/$id/define"
    | "/campaigns/$id/delivery"
    | "/campaigns/$id/planning"
    | "/campaigns/$id/start-campaign"
    | "/campaigns/setup/define/$category"
    | "/campaigns/setup/define/advanced"
    | "/campaigns/setup/delivery/integration"
    | "/campaigns/setup/planning/triggers"
    | "/campaigns/$id/details"
    | "/campaigns/setup/define/stop-lists"
    | "/campaigns/setup/delivery/configure"
    | "/campaigns/setup/delivery/method"
    | "/campaigns/setup/planning/contact-information"
    | "/campaigns/setup/planning/lead-amount"
    | "/campaigns/setup/planning/lead-amount-and-period"
    | "/campaigns/setup/planning/sales-strategy-and-prioritization"
    | "/campaigns/setup/planning/type"
    | "/campaigns/setup/summary/buy-credits"
    | "/settings/subscription"
    | "/settings/users"
    | "/campaigns/setup/define/"
    | "/campaigns/setup/details/"
    | "/campaigns/setup/summary/"
    | "/settings/company/"
    | "/settings/integrations/"
    | "/settings/stop-lists/"
    | "/settings/profile/"
    | "/campaigns/$id/adjust-week/$weekStart"
    | "/campaigns/$id/define/$category"
    | "/campaigns/$id/define/advanced"
    | "/campaigns/$id/delivery/setup"
    | "/campaigns/$id/planning/contact-information"
    | "/campaigns/$id/planning/lead-amount-and-period"
    | "/campaigns/$id/planning/triggers"
    | "/campaigns/setup/define/advanced/$quality"
    | "/campaigns/setup/delivery/integration/select"
    | "/campaigns/$id/boost/buy-credits"
    | "/campaigns/$id/boost/contact-information"
    | "/campaigns/$id/boost/lead-amount"
    | "/campaigns/$id/define/stop-lists"
    | "/campaigns/$id/delivery/buy-credits"
    | "/campaigns/$id/planning/sales-strategy-and-prioritization"
    | "/campaigns/$id/start-campaign/buy-credits"
    | "/campaigns/setup/define/$category/$filter"
    | "/campaigns/setup/define/$category/contacts"
    | "/campaigns/setup/delivery/integration/configure"
    | "/campaigns/setup/delivery/integration/method"
    | "/campaigns/setup/planning/triggers/$triggerId"
    | "/settings/integrations/$integration/connect"
    | "/settings/integrations/$integration/settings"
    | "/settings/subscription/add-credits"
    | "/settings/subscription/add-users"
    | "/settings/subscription/credit-usage"
    | "/settings/users/add-users"
    | "/settings/users/invite-new"
    | "/campaigns/$id/define/"
    | "/campaigns/$id/delivery/"
    | "/campaigns/$id/start-campaign/"
    | "/campaigns/setup/define/$category/"
    | "/campaigns/setup/define/advanced/"
    | "/campaigns/setup/planning/triggers/"
    | "/settings/invoices/"
    | "/settings/stop-lists/$id/"
    | "/settings/subscription/"
    | "/settings/users/$id/"
    | "/settings/users/"
    | "/campaigns/$id/define/advanced/$quality"
    | "/campaigns/$id/delivery/setup/integration"
    | "/campaigns/setup/define/advanced/$quality/$category"
    | "/campaigns/$id/adjust-week/$weekStart/buy-credits"
    | "/campaigns/$id/define/$category/$filter"
    | "/campaigns/$id/define/$category/contacts"
    | "/campaigns/$id/delivery/setup/buy-credits"
    | "/campaigns/$id/delivery/setup/configure"
    | "/campaigns/$id/delivery/setup/method"
    | "/campaigns/$id/planning/contact-information/buy-credits"
    | "/campaigns/$id/planning/lead-amount-and-period/buy-credits"
    | "/campaigns/$id/planning/triggers/$triggerId"
    | "/campaigns/setup/delivery/integration/select/new"
    | "/campaigns/$id/adjust-week/$weekStart/"
    | "/campaigns/$id/define/$category/"
    | "/campaigns/$id/define/advanced/"
    | "/campaigns/$id/planning/contact-information/"
    | "/campaigns/$id/planning/lead-amount-and-period/"
    | "/campaigns/$id/planning/triggers/"
    | "/campaigns/setup/delivery/integration/select/"
    | "/settings/integrations/$integration/$mode/"
    | "/campaigns/$id/define/advanced/$quality/$category"
    | "/campaigns/$id/delivery/setup/integration/select"
    | "/campaigns/$id/delivery/setup/integration/configure"
    | "/campaigns/$id/delivery/setup/integration/method"
    | "/campaigns/setup/define/advanced/$quality/$category/$filter"
    | "/campaigns/setup/define/advanced/$quality/$category/contacts"
    | "/campaigns/$id/define/advanced/$quality/$category/$filter"
    | "/campaigns/$id/define/advanced/$quality/$category/contacts"
    | "/campaigns/$id/delivery/setup/integration/select/new"
    | "/campaigns/$id/delivery/setup/integration/select/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/player"
    | "/hidden"
    | "/buy-credits"
    | "/intro-video"
    | "/start"
    | "/player/$id"
    | "/"
    | "/campaigns/setup"
    | "/settings"
    | "/campaigns"
    | "/leads"
    | "/performance"
    | "/campaigns/$id"
    | "/campaigns/setup/delivery"
    | "/campaigns/setup/planning"
    | "/campaigns/$id/boost"
    | "/campaigns/$id/planning"
    | "/campaigns/setup/delivery/integration"
    | "/campaigns/$id/details"
    | "/campaigns/setup/define/stop-lists"
    | "/campaigns/setup/delivery/configure"
    | "/campaigns/setup/delivery/method"
    | "/campaigns/setup/planning/contact-information"
    | "/campaigns/setup/planning/lead-amount"
    | "/campaigns/setup/planning/lead-amount-and-period"
    | "/campaigns/setup/planning/sales-strategy-and-prioritization"
    | "/campaigns/setup/planning/type"
    | "/campaigns/setup/summary/buy-credits"
    | "/campaigns/setup/define"
    | "/campaigns/setup/details"
    | "/campaigns/setup/summary"
    | "/settings/company"
    | "/settings/integrations"
    | "/settings/stop-lists"
    | "/settings/profile"
    | "/campaigns/$id/delivery/setup"
    | "/campaigns/setup/define/advanced/$quality"
    | "/campaigns/$id/boost/buy-credits"
    | "/campaigns/$id/boost/contact-information"
    | "/campaigns/$id/boost/lead-amount"
    | "/campaigns/$id/define/stop-lists"
    | "/campaigns/$id/delivery/buy-credits"
    | "/campaigns/$id/planning/sales-strategy-and-prioritization"
    | "/campaigns/$id/start-campaign/buy-credits"
    | "/campaigns/setup/define/$category/$filter"
    | "/campaigns/setup/define/$category/contacts"
    | "/campaigns/setup/delivery/integration/configure"
    | "/campaigns/setup/delivery/integration/method"
    | "/campaigns/setup/planning/triggers/$triggerId"
    | "/settings/integrations/$integration/connect"
    | "/settings/integrations/$integration/settings"
    | "/settings/subscription/add-credits"
    | "/settings/subscription/add-users"
    | "/settings/subscription/credit-usage"
    | "/settings/users/add-users"
    | "/settings/users/invite-new"
    | "/campaigns/$id/define"
    | "/campaigns/$id/delivery"
    | "/campaigns/$id/start-campaign"
    | "/campaigns/setup/define/$category"
    | "/campaigns/setup/define/advanced"
    | "/campaigns/setup/planning/triggers"
    | "/settings/invoices"
    | "/settings/stop-lists/$id"
    | "/settings/subscription"
    | "/settings/users/$id"
    | "/settings/users"
    | "/campaigns/$id/define/advanced/$quality"
    | "/campaigns/$id/delivery/setup/integration"
    | "/campaigns/setup/define/advanced/$quality/$category"
    | "/campaigns/$id/adjust-week/$weekStart/buy-credits"
    | "/campaigns/$id/define/$category/$filter"
    | "/campaigns/$id/define/$category/contacts"
    | "/campaigns/$id/delivery/setup/buy-credits"
    | "/campaigns/$id/delivery/setup/configure"
    | "/campaigns/$id/delivery/setup/method"
    | "/campaigns/$id/planning/contact-information/buy-credits"
    | "/campaigns/$id/planning/lead-amount-and-period/buy-credits"
    | "/campaigns/$id/planning/triggers/$triggerId"
    | "/campaigns/setup/delivery/integration/select/new"
    | "/campaigns/$id/adjust-week/$weekStart"
    | "/campaigns/$id/define/$category"
    | "/campaigns/$id/define/advanced"
    | "/campaigns/$id/planning/contact-information"
    | "/campaigns/$id/planning/lead-amount-and-period"
    | "/campaigns/$id/planning/triggers"
    | "/campaigns/setup/delivery/integration/select"
    | "/settings/integrations/$integration/$mode"
    | "/campaigns/$id/define/advanced/$quality/$category"
    | "/campaigns/$id/delivery/setup/integration/configure"
    | "/campaigns/$id/delivery/setup/integration/method"
    | "/campaigns/setup/define/advanced/$quality/$category/$filter"
    | "/campaigns/setup/define/advanced/$quality/$category/contacts"
    | "/campaigns/$id/define/advanced/$quality/$category/$filter"
    | "/campaigns/$id/define/advanced/$quality/$category/contacts"
    | "/campaigns/$id/delivery/setup/integration/select/new"
    | "/campaigns/$id/delivery/setup/integration/select"
  id:
    | "__root__"
    | "/_dashboard"
    | "/player"
    | "/_dashboard/hidden"
    | "/_dashboard/leads"
    | "/_dashboard/settings"
    | "/_dashboard/buy-credits"
    | "/_dashboard/intro-video"
    | "/_dashboard/start"
    | "/player/$id"
    | "/_dashboard/"
    | "/_dashboard/campaigns/$id"
    | "/_dashboard/campaigns/setup"
    | "/_dashboard/settings/_admin"
    | "/_dashboard/campaigns/"
    | "/_dashboard/leads/"
    | "/_dashboard/performance/"
    | "/_dashboard/settings/"
    | "/_dashboard/campaigns/$id/(edit)"
    | "/_dashboard/campaigns/setup/define"
    | "/_dashboard/campaigns/setup/delivery"
    | "/_dashboard/campaigns/setup/planning"
    | "/_dashboard/settings/_admin/_disabled"
    | "/_dashboard/settings/_admin/integrations"
    | "/_dashboard/settings/_admin/stop-lists"
    | "/_dashboard/settings/profile/_profile"
    | "/_dashboard/campaigns/$id/"
    | "/_dashboard/campaigns/$id/(edit)/boost"
    | "/_dashboard/campaigns/$id/(edit)/define"
    | "/_dashboard/campaigns/$id/(edit)/delivery"
    | "/_dashboard/campaigns/$id/(edit)/planning"
    | "/_dashboard/campaigns/$id/(edit)/start-campaign"
    | "/_dashboard/campaigns/setup/define/$category"
    | "/_dashboard/campaigns/setup/define/advanced"
    | "/_dashboard/campaigns/setup/delivery/integration"
    | "/_dashboard/campaigns/setup/planning/triggers"
    | "/_dashboard/campaigns/$id/(edit)/details"
    | "/_dashboard/campaigns/setup/define/stop-lists"
    | "/_dashboard/campaigns/setup/delivery/configure"
    | "/_dashboard/campaigns/setup/delivery/method"
    | "/_dashboard/campaigns/setup/planning/contact-information"
    | "/_dashboard/campaigns/setup/planning/lead-amount"
    | "/_dashboard/campaigns/setup/planning/lead-amount-and-period"
    | "/_dashboard/campaigns/setup/planning/sales-strategy-and-prioritization"
    | "/_dashboard/campaigns/setup/planning/type"
    | "/_dashboard/campaigns/setup/summary/buy-credits"
    | "/_dashboard/settings/_admin/subscription/_subscription"
    | "/_dashboard/settings/_admin/users/_users"
    | "/_dashboard/campaigns/setup/define/"
    | "/_dashboard/campaigns/setup/details/"
    | "/_dashboard/campaigns/setup/summary/"
    | "/_dashboard/settings/_admin/company/"
    | "/_dashboard/settings/_admin/integrations/"
    | "/_dashboard/settings/_admin/stop-lists/"
    | "/_dashboard/settings/profile/_profile/"
    | "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart"
    | "/_dashboard/campaigns/$id/(edit)/define/$category"
    | "/_dashboard/campaigns/$id/(edit)/define/advanced"
    | "/_dashboard/campaigns/$id/(edit)/delivery/setup"
    | "/_dashboard/campaigns/$id/(edit)/planning/contact-information"
    | "/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period"
    | "/_dashboard/campaigns/$id/(edit)/planning/triggers"
    | "/_dashboard/campaigns/setup/define/advanced/$quality"
    | "/_dashboard/campaigns/setup/delivery/integration/select"
    | "/_dashboard/campaigns/$id/(edit)/boost/buy-credits"
    | "/_dashboard/campaigns/$id/(edit)/boost/contact-information"
    | "/_dashboard/campaigns/$id/(edit)/boost/lead-amount"
    | "/_dashboard/campaigns/$id/(edit)/define/stop-lists"
    | "/_dashboard/campaigns/$id/(edit)/delivery/buy-credits"
    | "/_dashboard/campaigns/$id/(edit)/planning/sales-strategy-and-prioritization"
    | "/_dashboard/campaigns/$id/(edit)/start-campaign/buy-credits"
    | "/_dashboard/campaigns/setup/define/$category/$filter"
    | "/_dashboard/campaigns/setup/define/$category/contacts"
    | "/_dashboard/campaigns/setup/delivery/integration/configure"
    | "/_dashboard/campaigns/setup/delivery/integration/method"
    | "/_dashboard/campaigns/setup/planning/triggers/$triggerId"
    | "/_dashboard/settings/_admin/integrations/$integration/connect"
    | "/_dashboard/settings/_admin/integrations/$integration/settings"
    | "/_dashboard/settings/_admin/subscription/_subscription/add-credits"
    | "/_dashboard/settings/_admin/subscription/_subscription/add-users"
    | "/_dashboard/settings/_admin/subscription/_subscription/credit-usage"
    | "/_dashboard/settings/_admin/users/_users/add-users"
    | "/_dashboard/settings/_admin/users/_users/invite-new"
    | "/_dashboard/campaigns/$id/(edit)/define/"
    | "/_dashboard/campaigns/$id/(edit)/delivery/"
    | "/_dashboard/campaigns/$id/(edit)/start-campaign/"
    | "/_dashboard/campaigns/setup/define/$category/"
    | "/_dashboard/campaigns/setup/define/advanced/"
    | "/_dashboard/campaigns/setup/planning/triggers/"
    | "/_dashboard/settings/_admin/_disabled/invoices/"
    | "/_dashboard/settings/_admin/stop-lists/$id/"
    | "/_dashboard/settings/_admin/subscription/_subscription/"
    | "/_dashboard/settings/_admin/users/$id/"
    | "/_dashboard/settings/_admin/users/_users/"
    | "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality"
    | "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration"
    | "/_dashboard/campaigns/setup/define/advanced/$quality/$category"
    | "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart/buy-credits"
    | "/_dashboard/campaigns/$id/(edit)/define/$category/$filter"
    | "/_dashboard/campaigns/$id/(edit)/define/$category/contacts"
    | "/_dashboard/campaigns/$id/(edit)/delivery/setup/buy-credits"
    | "/_dashboard/campaigns/$id/(edit)/delivery/setup/configure"
    | "/_dashboard/campaigns/$id/(edit)/delivery/setup/method"
    | "/_dashboard/campaigns/$id/(edit)/planning/contact-information/buy-credits"
    | "/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period/buy-credits"
    | "/_dashboard/campaigns/$id/(edit)/planning/triggers/$triggerId"
    | "/_dashboard/campaigns/setup/delivery/integration/select/new"
    | "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart/"
    | "/_dashboard/campaigns/$id/(edit)/define/$category/"
    | "/_dashboard/campaigns/$id/(edit)/define/advanced/"
    | "/_dashboard/campaigns/$id/(edit)/planning/contact-information/"
    | "/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period/"
    | "/_dashboard/campaigns/$id/(edit)/planning/triggers/"
    | "/_dashboard/campaigns/setup/delivery/integration/select/"
    | "/_dashboard/settings/_admin/integrations/$integration/$mode/"
    | "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category"
    | "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select"
    | "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/configure"
    | "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/method"
    | "/_dashboard/campaigns/setup/define/advanced/$quality/$category/$filter"
    | "/_dashboard/campaigns/setup/define/advanced/$quality/$category/contacts"
    | "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category/$filter"
    | "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category/contacts"
    | "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select/new"
    | "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  PlayerRouteRoute: typeof PlayerRouteRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/player": {
      id: "/player"
      path: "/player"
      fullPath: "/player"
      preLoaderRoute: typeof PlayerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_dashboard": {
      id: "/_dashboard"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_dashboard/": {
      id: "/_dashboard/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/player/$id": {
      id: "/player/$id"
      path: "/$id"
      fullPath: "/player/$id"
      preLoaderRoute: typeof PlayerIdRouteImport
      parentRoute: typeof PlayerRouteRoute
    }
    "/_dashboard/start": {
      id: "/_dashboard/start"
      path: "/start"
      fullPath: "/start"
      preLoaderRoute: typeof DashboardStartRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/_dashboard/intro-video": {
      id: "/_dashboard/intro-video"
      path: "/intro-video"
      fullPath: "/intro-video"
      preLoaderRoute: typeof DashboardIntroVideoRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/_dashboard/buy-credits": {
      id: "/_dashboard/buy-credits"
      path: "/buy-credits"
      fullPath: "/buy-credits"
      preLoaderRoute: typeof DashboardBuyCreditsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/_dashboard/settings": {
      id: "/_dashboard/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof DashboardSettingsRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/_dashboard/leads": {
      id: "/_dashboard/leads"
      path: "/leads"
      fullPath: "/leads"
      preLoaderRoute: typeof DashboardLeadsRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/_dashboard/hidden": {
      id: "/_dashboard/hidden"
      path: "/hidden"
      fullPath: "/hidden"
      preLoaderRoute: typeof DashboardHiddenRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/_dashboard/settings/": {
      id: "/_dashboard/settings/"
      path: "/"
      fullPath: "/settings/"
      preLoaderRoute: typeof DashboardSettingsIndexRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    "/_dashboard/performance/": {
      id: "/_dashboard/performance/"
      path: "/performance"
      fullPath: "/performance/"
      preLoaderRoute: typeof DashboardPerformanceIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/_dashboard/leads/": {
      id: "/_dashboard/leads/"
      path: "/"
      fullPath: "/leads/"
      preLoaderRoute: typeof DashboardLeadsIndexRouteImport
      parentRoute: typeof DashboardLeadsRouteRoute
    }
    "/_dashboard/campaigns/": {
      id: "/_dashboard/campaigns/"
      path: "/campaigns"
      fullPath: "/campaigns/"
      preLoaderRoute: typeof DashboardCampaignsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/_dashboard/settings/_admin": {
      id: "/_dashboard/settings/_admin"
      path: ""
      fullPath: "/settings"
      preLoaderRoute: typeof DashboardSettingsAdminRouteRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    "/_dashboard/campaigns/setup": {
      id: "/_dashboard/campaigns/setup"
      path: "/campaigns/setup"
      fullPath: "/campaigns/setup"
      preLoaderRoute: typeof DashboardCampaignsSetupRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/_dashboard/campaigns/$id": {
      id: "/_dashboard/campaigns/$id"
      path: "/campaigns/$id"
      fullPath: "/campaigns/$id"
      preLoaderRoute: typeof DashboardCampaignsIdRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    "/_dashboard/campaigns/$id/": {
      id: "/_dashboard/campaigns/$id/"
      path: "/"
      fullPath: "/campaigns/$id/"
      preLoaderRoute: typeof DashboardCampaignsIdIndexRouteImport
      parentRoute: typeof DashboardCampaignsIdRouteRoute
    }
    "/_dashboard/settings/profile/_profile": {
      id: "/_dashboard/settings/profile/_profile"
      path: "/profile"
      fullPath: "/settings/profile"
      preLoaderRoute: typeof DashboardSettingsProfileProfileRouteImport
      parentRoute: typeof DashboardSettingsRouteRoute
    }
    "/_dashboard/settings/_admin/stop-lists": {
      id: "/_dashboard/settings/_admin/stop-lists"
      path: "/stop-lists"
      fullPath: "/settings/stop-lists"
      preLoaderRoute: typeof DashboardSettingsAdminStopListsRouteRouteImport
      parentRoute: typeof DashboardSettingsAdminRouteRoute
    }
    "/_dashboard/settings/_admin/integrations": {
      id: "/_dashboard/settings/_admin/integrations"
      path: "/integrations"
      fullPath: "/settings/integrations"
      preLoaderRoute: typeof DashboardSettingsAdminIntegrationsRouteRouteImport
      parentRoute: typeof DashboardSettingsAdminRouteRoute
    }
    "/_dashboard/settings/_admin/_disabled": {
      id: "/_dashboard/settings/_admin/_disabled"
      path: ""
      fullPath: "/settings"
      preLoaderRoute: typeof DashboardSettingsAdminDisabledRouteRouteImport
      parentRoute: typeof DashboardSettingsAdminRouteRoute
    }
    "/_dashboard/campaigns/setup/planning": {
      id: "/_dashboard/campaigns/setup/planning"
      path: "/planning"
      fullPath: "/campaigns/setup/planning"
      preLoaderRoute: typeof DashboardCampaignsSetupPlanningRouteRouteImport
      parentRoute: typeof DashboardCampaignsSetupRouteRoute
    }
    "/_dashboard/campaigns/setup/delivery": {
      id: "/_dashboard/campaigns/setup/delivery"
      path: "/delivery"
      fullPath: "/campaigns/setup/delivery"
      preLoaderRoute: typeof DashboardCampaignsSetupDeliveryRouteRouteImport
      parentRoute: typeof DashboardCampaignsSetupRouteRoute
    }
    "/_dashboard/campaigns/setup/define": {
      id: "/_dashboard/campaigns/setup/define"
      path: "/define"
      fullPath: "/campaigns/setup/define"
      preLoaderRoute: typeof DashboardCampaignsSetupDefineRouteRouteImport
      parentRoute: typeof DashboardCampaignsSetupRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)": {
      id: "/_dashboard/campaigns/$id/(edit)"
      path: ""
      fullPath: "/campaigns/$id"
      preLoaderRoute: typeof DashboardCampaignsIdeditRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdRouteRoute
    }
    "/_dashboard/settings/profile/_profile/": {
      id: "/_dashboard/settings/profile/_profile/"
      path: "/"
      fullPath: "/settings/profile/"
      preLoaderRoute: typeof DashboardSettingsProfileProfileIndexRouteImport
      parentRoute: typeof DashboardSettingsProfileProfileRoute
    }
    "/_dashboard/settings/_admin/stop-lists/": {
      id: "/_dashboard/settings/_admin/stop-lists/"
      path: "/"
      fullPath: "/settings/stop-lists/"
      preLoaderRoute: typeof DashboardSettingsAdminStopListsIndexRouteImport
      parentRoute: typeof DashboardSettingsAdminStopListsRouteRoute
    }
    "/_dashboard/settings/_admin/integrations/": {
      id: "/_dashboard/settings/_admin/integrations/"
      path: "/"
      fullPath: "/settings/integrations/"
      preLoaderRoute: typeof DashboardSettingsAdminIntegrationsIndexRouteImport
      parentRoute: typeof DashboardSettingsAdminIntegrationsRouteRoute
    }
    "/_dashboard/settings/_admin/company/": {
      id: "/_dashboard/settings/_admin/company/"
      path: "/company"
      fullPath: "/settings/company/"
      preLoaderRoute: typeof DashboardSettingsAdminCompanyIndexRouteImport
      parentRoute: typeof DashboardSettingsAdminRouteRoute
    }
    "/_dashboard/campaigns/setup/summary/": {
      id: "/_dashboard/campaigns/setup/summary/"
      path: "/summary"
      fullPath: "/campaigns/setup/summary/"
      preLoaderRoute: typeof DashboardCampaignsSetupSummaryIndexRouteImport
      parentRoute: typeof DashboardCampaignsSetupRouteRoute
    }
    "/_dashboard/campaigns/setup/details/": {
      id: "/_dashboard/campaigns/setup/details/"
      path: "/details"
      fullPath: "/campaigns/setup/details/"
      preLoaderRoute: typeof DashboardCampaignsSetupDetailsIndexRouteImport
      parentRoute: typeof DashboardCampaignsSetupRouteRoute
    }
    "/_dashboard/campaigns/setup/define/": {
      id: "/_dashboard/campaigns/setup/define/"
      path: "/"
      fullPath: "/campaigns/setup/define/"
      preLoaderRoute: typeof DashboardCampaignsSetupDefineIndexRouteImport
      parentRoute: typeof DashboardCampaignsSetupDefineRouteRoute
    }
    "/_dashboard/settings/_admin/users/_users": {
      id: "/_dashboard/settings/_admin/users/_users"
      path: "/users"
      fullPath: "/settings/users"
      preLoaderRoute: typeof DashboardSettingsAdminUsersUsersRouteImport
      parentRoute: typeof DashboardSettingsAdminRouteRoute
    }
    "/_dashboard/settings/_admin/subscription/_subscription": {
      id: "/_dashboard/settings/_admin/subscription/_subscription"
      path: "/subscription"
      fullPath: "/settings/subscription"
      preLoaderRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionRouteImport
      parentRoute: typeof DashboardSettingsAdminRouteRoute
    }
    "/_dashboard/campaigns/setup/summary/buy-credits": {
      id: "/_dashboard/campaigns/setup/summary/buy-credits"
      path: "/summary/buy-credits"
      fullPath: "/campaigns/setup/summary/buy-credits"
      preLoaderRoute: typeof DashboardCampaignsSetupSummaryBuyCreditsRouteImport
      parentRoute: typeof DashboardCampaignsSetupRouteRoute
    }
    "/_dashboard/campaigns/setup/planning/type": {
      id: "/_dashboard/campaigns/setup/planning/type"
      path: "/type"
      fullPath: "/campaigns/setup/planning/type"
      preLoaderRoute: typeof DashboardCampaignsSetupPlanningTypeRouteImport
      parentRoute: typeof DashboardCampaignsSetupPlanningRouteRoute
    }
    "/_dashboard/campaigns/setup/planning/sales-strategy-and-prioritization": {
      id: "/_dashboard/campaigns/setup/planning/sales-strategy-and-prioritization"
      path: "/sales-strategy-and-prioritization"
      fullPath: "/campaigns/setup/planning/sales-strategy-and-prioritization"
      preLoaderRoute: typeof DashboardCampaignsSetupPlanningSalesStrategyAndPrioritizationRouteImport
      parentRoute: typeof DashboardCampaignsSetupPlanningRouteRoute
    }
    "/_dashboard/campaigns/setup/planning/lead-amount-and-period": {
      id: "/_dashboard/campaigns/setup/planning/lead-amount-and-period"
      path: "/lead-amount-and-period"
      fullPath: "/campaigns/setup/planning/lead-amount-and-period"
      preLoaderRoute: typeof DashboardCampaignsSetupPlanningLeadAmountAndPeriodRouteImport
      parentRoute: typeof DashboardCampaignsSetupPlanningRouteRoute
    }
    "/_dashboard/campaigns/setup/planning/lead-amount": {
      id: "/_dashboard/campaigns/setup/planning/lead-amount"
      path: "/lead-amount"
      fullPath: "/campaigns/setup/planning/lead-amount"
      preLoaderRoute: typeof DashboardCampaignsSetupPlanningLeadAmountRouteImport
      parentRoute: typeof DashboardCampaignsSetupPlanningRouteRoute
    }
    "/_dashboard/campaigns/setup/planning/contact-information": {
      id: "/_dashboard/campaigns/setup/planning/contact-information"
      path: "/contact-information"
      fullPath: "/campaigns/setup/planning/contact-information"
      preLoaderRoute: typeof DashboardCampaignsSetupPlanningContactInformationRouteImport
      parentRoute: typeof DashboardCampaignsSetupPlanningRouteRoute
    }
    "/_dashboard/campaigns/setup/delivery/method": {
      id: "/_dashboard/campaigns/setup/delivery/method"
      path: "/method"
      fullPath: "/campaigns/setup/delivery/method"
      preLoaderRoute: typeof DashboardCampaignsSetupDeliveryMethodRouteImport
      parentRoute: typeof DashboardCampaignsSetupDeliveryRouteRoute
    }
    "/_dashboard/campaigns/setup/delivery/configure": {
      id: "/_dashboard/campaigns/setup/delivery/configure"
      path: "/configure"
      fullPath: "/campaigns/setup/delivery/configure"
      preLoaderRoute: typeof DashboardCampaignsSetupDeliveryConfigureRouteImport
      parentRoute: typeof DashboardCampaignsSetupDeliveryRouteRoute
    }
    "/_dashboard/campaigns/setup/define/stop-lists": {
      id: "/_dashboard/campaigns/setup/define/stop-lists"
      path: "/stop-lists"
      fullPath: "/campaigns/setup/define/stop-lists"
      preLoaderRoute: typeof DashboardCampaignsSetupDefineStopListsRouteImport
      parentRoute: typeof DashboardCampaignsSetupDefineRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/details": {
      id: "/_dashboard/campaigns/$id/(edit)/details"
      path: "/details"
      fullPath: "/campaigns/$id/details"
      preLoaderRoute: typeof DashboardCampaignsIdeditDetailsRouteImport
      parentRoute: typeof DashboardCampaignsIdeditRouteRoute
    }
    "/_dashboard/campaigns/setup/planning/triggers": {
      id: "/_dashboard/campaigns/setup/planning/triggers"
      path: "/triggers"
      fullPath: "/campaigns/setup/planning/triggers"
      preLoaderRoute: typeof DashboardCampaignsSetupPlanningTriggersRouteRouteImport
      parentRoute: typeof DashboardCampaignsSetupPlanningRouteRoute
    }
    "/_dashboard/campaigns/setup/delivery/integration": {
      id: "/_dashboard/campaigns/setup/delivery/integration"
      path: "/integration"
      fullPath: "/campaigns/setup/delivery/integration"
      preLoaderRoute: typeof DashboardCampaignsSetupDeliveryIntegrationRouteRouteImport
      parentRoute: typeof DashboardCampaignsSetupDeliveryRouteRoute
    }
    "/_dashboard/campaigns/setup/define/advanced": {
      id: "/_dashboard/campaigns/setup/define/advanced"
      path: "/advanced"
      fullPath: "/campaigns/setup/define/advanced"
      preLoaderRoute: typeof DashboardCampaignsSetupDefineAdvancedRouteRouteImport
      parentRoute: typeof DashboardCampaignsSetupDefineRouteRoute
    }
    "/_dashboard/campaigns/setup/define/$category": {
      id: "/_dashboard/campaigns/setup/define/$category"
      path: "/$category"
      fullPath: "/campaigns/setup/define/$category"
      preLoaderRoute: typeof DashboardCampaignsSetupDefineCategoryRouteRouteImport
      parentRoute: typeof DashboardCampaignsSetupDefineRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/start-campaign": {
      id: "/_dashboard/campaigns/$id/(edit)/start-campaign"
      path: "/start-campaign"
      fullPath: "/campaigns/$id/start-campaign"
      preLoaderRoute: typeof DashboardCampaignsIdeditStartCampaignRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/planning": {
      id: "/_dashboard/campaigns/$id/(edit)/planning"
      path: "/planning"
      fullPath: "/campaigns/$id/planning"
      preLoaderRoute: typeof DashboardCampaignsIdeditPlanningRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/delivery": {
      id: "/_dashboard/campaigns/$id/(edit)/delivery"
      path: "/delivery"
      fullPath: "/campaigns/$id/delivery"
      preLoaderRoute: typeof DashboardCampaignsIdeditDeliveryRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/define": {
      id: "/_dashboard/campaigns/$id/(edit)/define"
      path: "/define"
      fullPath: "/campaigns/$id/define"
      preLoaderRoute: typeof DashboardCampaignsIdeditDefineRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/boost": {
      id: "/_dashboard/campaigns/$id/(edit)/boost"
      path: "/boost"
      fullPath: "/campaigns/$id/boost"
      preLoaderRoute: typeof DashboardCampaignsIdeditBoostRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditRouteRoute
    }
    "/_dashboard/settings/_admin/users/_users/": {
      id: "/_dashboard/settings/_admin/users/_users/"
      path: "/"
      fullPath: "/settings/users/"
      preLoaderRoute: typeof DashboardSettingsAdminUsersUsersIndexRouteImport
      parentRoute: typeof DashboardSettingsAdminUsersUsersRoute
    }
    "/_dashboard/settings/_admin/users/$id/": {
      id: "/_dashboard/settings/_admin/users/$id/"
      path: "/users/$id"
      fullPath: "/settings/users/$id/"
      preLoaderRoute: typeof DashboardSettingsAdminUsersIdIndexRouteImport
      parentRoute: typeof DashboardSettingsAdminRouteRoute
    }
    "/_dashboard/settings/_admin/subscription/_subscription/": {
      id: "/_dashboard/settings/_admin/subscription/_subscription/"
      path: "/"
      fullPath: "/settings/subscription/"
      preLoaderRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionIndexRouteImport
      parentRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionRoute
    }
    "/_dashboard/settings/_admin/stop-lists/$id/": {
      id: "/_dashboard/settings/_admin/stop-lists/$id/"
      path: "/$id"
      fullPath: "/settings/stop-lists/$id/"
      preLoaderRoute: typeof DashboardSettingsAdminStopListsIdIndexRouteImport
      parentRoute: typeof DashboardSettingsAdminStopListsRouteRoute
    }
    "/_dashboard/settings/_admin/_disabled/invoices/": {
      id: "/_dashboard/settings/_admin/_disabled/invoices/"
      path: "/invoices"
      fullPath: "/settings/invoices/"
      preLoaderRoute: typeof DashboardSettingsAdminDisabledInvoicesIndexRouteImport
      parentRoute: typeof DashboardSettingsAdminDisabledRouteRoute
    }
    "/_dashboard/campaigns/setup/planning/triggers/": {
      id: "/_dashboard/campaigns/setup/planning/triggers/"
      path: "/"
      fullPath: "/campaigns/setup/planning/triggers/"
      preLoaderRoute: typeof DashboardCampaignsSetupPlanningTriggersIndexRouteImport
      parentRoute: typeof DashboardCampaignsSetupPlanningTriggersRouteRoute
    }
    "/_dashboard/campaigns/setup/define/advanced/": {
      id: "/_dashboard/campaigns/setup/define/advanced/"
      path: "/"
      fullPath: "/campaigns/setup/define/advanced/"
      preLoaderRoute: typeof DashboardCampaignsSetupDefineAdvancedIndexRouteImport
      parentRoute: typeof DashboardCampaignsSetupDefineAdvancedRouteRoute
    }
    "/_dashboard/campaigns/setup/define/$category/": {
      id: "/_dashboard/campaigns/setup/define/$category/"
      path: "/"
      fullPath: "/campaigns/setup/define/$category/"
      preLoaderRoute: typeof DashboardCampaignsSetupDefineCategoryIndexRouteImport
      parentRoute: typeof DashboardCampaignsSetupDefineCategoryRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/start-campaign/": {
      id: "/_dashboard/campaigns/$id/(edit)/start-campaign/"
      path: "/"
      fullPath: "/campaigns/$id/start-campaign/"
      preLoaderRoute: typeof DashboardCampaignsIdeditStartCampaignIndexRouteImport
      parentRoute: typeof DashboardCampaignsIdeditStartCampaignRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/delivery/": {
      id: "/_dashboard/campaigns/$id/(edit)/delivery/"
      path: "/"
      fullPath: "/campaigns/$id/delivery/"
      preLoaderRoute: typeof DashboardCampaignsIdeditDeliveryIndexRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDeliveryRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/define/": {
      id: "/_dashboard/campaigns/$id/(edit)/define/"
      path: "/"
      fullPath: "/campaigns/$id/define/"
      preLoaderRoute: typeof DashboardCampaignsIdeditDefineIndexRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDefineRouteRoute
    }
    "/_dashboard/settings/_admin/users/_users/invite-new": {
      id: "/_dashboard/settings/_admin/users/_users/invite-new"
      path: "/invite-new"
      fullPath: "/settings/users/invite-new"
      preLoaderRoute: typeof DashboardSettingsAdminUsersUsersInviteNewRouteImport
      parentRoute: typeof DashboardSettingsAdminUsersUsersRoute
    }
    "/_dashboard/settings/_admin/users/_users/add-users": {
      id: "/_dashboard/settings/_admin/users/_users/add-users"
      path: "/add-users"
      fullPath: "/settings/users/add-users"
      preLoaderRoute: typeof DashboardSettingsAdminUsersUsersAddUsersRouteImport
      parentRoute: typeof DashboardSettingsAdminUsersUsersRoute
    }
    "/_dashboard/settings/_admin/subscription/_subscription/credit-usage": {
      id: "/_dashboard/settings/_admin/subscription/_subscription/credit-usage"
      path: "/credit-usage"
      fullPath: "/settings/subscription/credit-usage"
      preLoaderRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionCreditUsageRouteImport
      parentRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionRoute
    }
    "/_dashboard/settings/_admin/subscription/_subscription/add-users": {
      id: "/_dashboard/settings/_admin/subscription/_subscription/add-users"
      path: "/add-users"
      fullPath: "/settings/subscription/add-users"
      preLoaderRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionAddUsersRouteImport
      parentRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionRoute
    }
    "/_dashboard/settings/_admin/subscription/_subscription/add-credits": {
      id: "/_dashboard/settings/_admin/subscription/_subscription/add-credits"
      path: "/add-credits"
      fullPath: "/settings/subscription/add-credits"
      preLoaderRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionAddCreditsRouteImport
      parentRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionRoute
    }
    "/_dashboard/settings/_admin/integrations/$integration/settings": {
      id: "/_dashboard/settings/_admin/integrations/$integration/settings"
      path: "/$integration/settings"
      fullPath: "/settings/integrations/$integration/settings"
      preLoaderRoute: typeof DashboardSettingsAdminIntegrationsIntegrationSettingsRouteImport
      parentRoute: typeof DashboardSettingsAdminIntegrationsRouteRoute
    }
    "/_dashboard/settings/_admin/integrations/$integration/connect": {
      id: "/_dashboard/settings/_admin/integrations/$integration/connect"
      path: "/$integration/connect"
      fullPath: "/settings/integrations/$integration/connect"
      preLoaderRoute: typeof DashboardSettingsAdminIntegrationsIntegrationConnectRouteImport
      parentRoute: typeof DashboardSettingsAdminIntegrationsRouteRoute
    }
    "/_dashboard/campaigns/setup/planning/triggers/$triggerId": {
      id: "/_dashboard/campaigns/setup/planning/triggers/$triggerId"
      path: "/$triggerId"
      fullPath: "/campaigns/setup/planning/triggers/$triggerId"
      preLoaderRoute: typeof DashboardCampaignsSetupPlanningTriggersTriggerIdRouteImport
      parentRoute: typeof DashboardCampaignsSetupPlanningTriggersRouteRoute
    }
    "/_dashboard/campaigns/setup/delivery/integration/method": {
      id: "/_dashboard/campaigns/setup/delivery/integration/method"
      path: "/method"
      fullPath: "/campaigns/setup/delivery/integration/method"
      preLoaderRoute: typeof DashboardCampaignsSetupDeliveryIntegrationMethodRouteImport
      parentRoute: typeof DashboardCampaignsSetupDeliveryIntegrationRouteRoute
    }
    "/_dashboard/campaigns/setup/delivery/integration/configure": {
      id: "/_dashboard/campaigns/setup/delivery/integration/configure"
      path: "/configure"
      fullPath: "/campaigns/setup/delivery/integration/configure"
      preLoaderRoute: typeof DashboardCampaignsSetupDeliveryIntegrationConfigureRouteImport
      parentRoute: typeof DashboardCampaignsSetupDeliveryIntegrationRouteRoute
    }
    "/_dashboard/campaigns/setup/define/$category/contacts": {
      id: "/_dashboard/campaigns/setup/define/$category/contacts"
      path: "/contacts"
      fullPath: "/campaigns/setup/define/$category/contacts"
      preLoaderRoute: typeof DashboardCampaignsSetupDefineCategoryContactsRouteImport
      parentRoute: typeof DashboardCampaignsSetupDefineCategoryRouteRoute
    }
    "/_dashboard/campaigns/setup/define/$category/$filter": {
      id: "/_dashboard/campaigns/setup/define/$category/$filter"
      path: "/$filter"
      fullPath: "/campaigns/setup/define/$category/$filter"
      preLoaderRoute: typeof DashboardCampaignsSetupDefineCategoryFilterRouteImport
      parentRoute: typeof DashboardCampaignsSetupDefineCategoryRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/start-campaign/buy-credits": {
      id: "/_dashboard/campaigns/$id/(edit)/start-campaign/buy-credits"
      path: "/buy-credits"
      fullPath: "/campaigns/$id/start-campaign/buy-credits"
      preLoaderRoute: typeof DashboardCampaignsIdeditStartCampaignBuyCreditsRouteImport
      parentRoute: typeof DashboardCampaignsIdeditStartCampaignRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/planning/sales-strategy-and-prioritization": {
      id: "/_dashboard/campaigns/$id/(edit)/planning/sales-strategy-and-prioritization"
      path: "/sales-strategy-and-prioritization"
      fullPath: "/campaigns/$id/planning/sales-strategy-and-prioritization"
      preLoaderRoute: typeof DashboardCampaignsIdeditPlanningSalesStrategyAndPrioritizationRouteImport
      parentRoute: typeof DashboardCampaignsIdeditPlanningRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/delivery/buy-credits": {
      id: "/_dashboard/campaigns/$id/(edit)/delivery/buy-credits"
      path: "/buy-credits"
      fullPath: "/campaigns/$id/delivery/buy-credits"
      preLoaderRoute: typeof DashboardCampaignsIdeditDeliveryBuyCreditsRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDeliveryRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/define/stop-lists": {
      id: "/_dashboard/campaigns/$id/(edit)/define/stop-lists"
      path: "/stop-lists"
      fullPath: "/campaigns/$id/define/stop-lists"
      preLoaderRoute: typeof DashboardCampaignsIdeditDefineStopListsRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDefineRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/boost/lead-amount": {
      id: "/_dashboard/campaigns/$id/(edit)/boost/lead-amount"
      path: "/lead-amount"
      fullPath: "/campaigns/$id/boost/lead-amount"
      preLoaderRoute: typeof DashboardCampaignsIdeditBoostLeadAmountRouteImport
      parentRoute: typeof DashboardCampaignsIdeditBoostRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/boost/contact-information": {
      id: "/_dashboard/campaigns/$id/(edit)/boost/contact-information"
      path: "/contact-information"
      fullPath: "/campaigns/$id/boost/contact-information"
      preLoaderRoute: typeof DashboardCampaignsIdeditBoostContactInformationRouteImport
      parentRoute: typeof DashboardCampaignsIdeditBoostRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/boost/buy-credits": {
      id: "/_dashboard/campaigns/$id/(edit)/boost/buy-credits"
      path: "/buy-credits"
      fullPath: "/campaigns/$id/boost/buy-credits"
      preLoaderRoute: typeof DashboardCampaignsIdeditBoostBuyCreditsRouteImport
      parentRoute: typeof DashboardCampaignsIdeditBoostRouteRoute
    }
    "/_dashboard/campaigns/setup/delivery/integration/select": {
      id: "/_dashboard/campaigns/setup/delivery/integration/select"
      path: "/select"
      fullPath: "/campaigns/setup/delivery/integration/select"
      preLoaderRoute: typeof DashboardCampaignsSetupDeliveryIntegrationSelectRouteRouteImport
      parentRoute: typeof DashboardCampaignsSetupDeliveryIntegrationRouteRoute
    }
    "/_dashboard/campaigns/setup/define/advanced/$quality": {
      id: "/_dashboard/campaigns/setup/define/advanced/$quality"
      path: "/$quality"
      fullPath: "/campaigns/setup/define/advanced/$quality"
      preLoaderRoute: typeof DashboardCampaignsSetupDefineAdvancedQualityRouteRouteImport
      parentRoute: typeof DashboardCampaignsSetupDefineAdvancedRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/planning/triggers": {
      id: "/_dashboard/campaigns/$id/(edit)/planning/triggers"
      path: "/triggers"
      fullPath: "/campaigns/$id/planning/triggers"
      preLoaderRoute: typeof DashboardCampaignsIdeditPlanningTriggersRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditPlanningRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period": {
      id: "/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period"
      path: "/lead-amount-and-period"
      fullPath: "/campaigns/$id/planning/lead-amount-and-period"
      preLoaderRoute: typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditPlanningRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/planning/contact-information": {
      id: "/_dashboard/campaigns/$id/(edit)/planning/contact-information"
      path: "/contact-information"
      fullPath: "/campaigns/$id/planning/contact-information"
      preLoaderRoute: typeof DashboardCampaignsIdeditPlanningContactInformationRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditPlanningRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/delivery/setup": {
      id: "/_dashboard/campaigns/$id/(edit)/delivery/setup"
      path: "/setup"
      fullPath: "/campaigns/$id/delivery/setup"
      preLoaderRoute: typeof DashboardCampaignsIdeditDeliverySetupRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDeliveryRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/define/advanced": {
      id: "/_dashboard/campaigns/$id/(edit)/define/advanced"
      path: "/advanced"
      fullPath: "/campaigns/$id/define/advanced"
      preLoaderRoute: typeof DashboardCampaignsIdeditDefineAdvancedRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDefineRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/define/$category": {
      id: "/_dashboard/campaigns/$id/(edit)/define/$category"
      path: "/$category"
      fullPath: "/campaigns/$id/define/$category"
      preLoaderRoute: typeof DashboardCampaignsIdeditDefineCategoryRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDefineRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart": {
      id: "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart"
      path: "/adjust-week/$weekStart"
      fullPath: "/campaigns/$id/adjust-week/$weekStart"
      preLoaderRoute: typeof DashboardCampaignsIdeditAdjustWeekWeekStartRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditRouteRoute
    }
    "/_dashboard/settings/_admin/integrations/$integration/$mode/": {
      id: "/_dashboard/settings/_admin/integrations/$integration/$mode/"
      path: "/$integration/$mode"
      fullPath: "/settings/integrations/$integration/$mode/"
      preLoaderRoute: typeof DashboardSettingsAdminIntegrationsIntegrationModeIndexRouteImport
      parentRoute: typeof DashboardSettingsAdminIntegrationsRouteRoute
    }
    "/_dashboard/campaigns/setup/delivery/integration/select/": {
      id: "/_dashboard/campaigns/setup/delivery/integration/select/"
      path: "/"
      fullPath: "/campaigns/setup/delivery/integration/select/"
      preLoaderRoute: typeof DashboardCampaignsSetupDeliveryIntegrationSelectIndexRouteImport
      parentRoute: typeof DashboardCampaignsSetupDeliveryIntegrationSelectRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/planning/triggers/": {
      id: "/_dashboard/campaigns/$id/(edit)/planning/triggers/"
      path: "/"
      fullPath: "/campaigns/$id/planning/triggers/"
      preLoaderRoute: typeof DashboardCampaignsIdeditPlanningTriggersIndexRouteImport
      parentRoute: typeof DashboardCampaignsIdeditPlanningTriggersRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period/": {
      id: "/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period/"
      path: "/"
      fullPath: "/campaigns/$id/planning/lead-amount-and-period/"
      preLoaderRoute: typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodIndexRouteImport
      parentRoute: typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/planning/contact-information/": {
      id: "/_dashboard/campaigns/$id/(edit)/planning/contact-information/"
      path: "/"
      fullPath: "/campaigns/$id/planning/contact-information/"
      preLoaderRoute: typeof DashboardCampaignsIdeditPlanningContactInformationIndexRouteImport
      parentRoute: typeof DashboardCampaignsIdeditPlanningContactInformationRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/define/advanced/": {
      id: "/_dashboard/campaigns/$id/(edit)/define/advanced/"
      path: "/"
      fullPath: "/campaigns/$id/define/advanced/"
      preLoaderRoute: typeof DashboardCampaignsIdeditDefineAdvancedIndexRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDefineAdvancedRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/define/$category/": {
      id: "/_dashboard/campaigns/$id/(edit)/define/$category/"
      path: "/"
      fullPath: "/campaigns/$id/define/$category/"
      preLoaderRoute: typeof DashboardCampaignsIdeditDefineCategoryIndexRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDefineCategoryRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart/": {
      id: "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart/"
      path: "/"
      fullPath: "/campaigns/$id/adjust-week/$weekStart/"
      preLoaderRoute: typeof DashboardCampaignsIdeditAdjustWeekWeekStartIndexRouteImport
      parentRoute: typeof DashboardCampaignsIdeditAdjustWeekWeekStartRouteRoute
    }
    "/_dashboard/campaigns/setup/delivery/integration/select/new": {
      id: "/_dashboard/campaigns/setup/delivery/integration/select/new"
      path: "/new"
      fullPath: "/campaigns/setup/delivery/integration/select/new"
      preLoaderRoute: typeof DashboardCampaignsSetupDeliveryIntegrationSelectNewRouteImport
      parentRoute: typeof DashboardCampaignsSetupDeliveryIntegrationSelectRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/planning/triggers/$triggerId": {
      id: "/_dashboard/campaigns/$id/(edit)/planning/triggers/$triggerId"
      path: "/$triggerId"
      fullPath: "/campaigns/$id/planning/triggers/$triggerId"
      preLoaderRoute: typeof DashboardCampaignsIdeditPlanningTriggersTriggerIdRouteImport
      parentRoute: typeof DashboardCampaignsIdeditPlanningTriggersRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period/buy-credits": {
      id: "/_dashboard/campaigns/$id/(edit)/planning/lead-amount-and-period/buy-credits"
      path: "/buy-credits"
      fullPath: "/campaigns/$id/planning/lead-amount-and-period/buy-credits"
      preLoaderRoute: typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodBuyCreditsRouteImport
      parentRoute: typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/planning/contact-information/buy-credits": {
      id: "/_dashboard/campaigns/$id/(edit)/planning/contact-information/buy-credits"
      path: "/buy-credits"
      fullPath: "/campaigns/$id/planning/contact-information/buy-credits"
      preLoaderRoute: typeof DashboardCampaignsIdeditPlanningContactInformationBuyCreditsRouteImport
      parentRoute: typeof DashboardCampaignsIdeditPlanningContactInformationRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/delivery/setup/method": {
      id: "/_dashboard/campaigns/$id/(edit)/delivery/setup/method"
      path: "/method"
      fullPath: "/campaigns/$id/delivery/setup/method"
      preLoaderRoute: typeof DashboardCampaignsIdeditDeliverySetupMethodRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDeliverySetupRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/delivery/setup/configure": {
      id: "/_dashboard/campaigns/$id/(edit)/delivery/setup/configure"
      path: "/configure"
      fullPath: "/campaigns/$id/delivery/setup/configure"
      preLoaderRoute: typeof DashboardCampaignsIdeditDeliverySetupConfigureRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDeliverySetupRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/delivery/setup/buy-credits": {
      id: "/_dashboard/campaigns/$id/(edit)/delivery/setup/buy-credits"
      path: "/buy-credits"
      fullPath: "/campaigns/$id/delivery/setup/buy-credits"
      preLoaderRoute: typeof DashboardCampaignsIdeditDeliverySetupBuyCreditsRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDeliverySetupRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/define/$category/contacts": {
      id: "/_dashboard/campaigns/$id/(edit)/define/$category/contacts"
      path: "/contacts"
      fullPath: "/campaigns/$id/define/$category/contacts"
      preLoaderRoute: typeof DashboardCampaignsIdeditDefineCategoryContactsRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDefineCategoryRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/define/$category/$filter": {
      id: "/_dashboard/campaigns/$id/(edit)/define/$category/$filter"
      path: "/$filter"
      fullPath: "/campaigns/$id/define/$category/$filter"
      preLoaderRoute: typeof DashboardCampaignsIdeditDefineCategoryFilterRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDefineCategoryRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart/buy-credits": {
      id: "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart/buy-credits"
      path: "/buy-credits"
      fullPath: "/campaigns/$id/adjust-week/$weekStart/buy-credits"
      preLoaderRoute: typeof DashboardCampaignsIdeditAdjustWeekWeekStartBuyCreditsRouteImport
      parentRoute: typeof DashboardCampaignsIdeditAdjustWeekWeekStartRouteRoute
    }
    "/_dashboard/campaigns/setup/define/advanced/$quality/$category": {
      id: "/_dashboard/campaigns/setup/define/advanced/$quality/$category"
      path: "/$category"
      fullPath: "/campaigns/setup/define/advanced/$quality/$category"
      preLoaderRoute: typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRouteImport
      parentRoute: typeof DashboardCampaignsSetupDefineAdvancedQualityRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration": {
      id: "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration"
      path: "/integration"
      fullPath: "/campaigns/$id/delivery/setup/integration"
      preLoaderRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDeliverySetupRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality": {
      id: "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality"
      path: "/$quality"
      fullPath: "/campaigns/$id/define/advanced/$quality"
      preLoaderRoute: typeof DashboardCampaignsIdeditDefineAdvancedQualityRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDefineAdvancedRouteRoute
    }
    "/_dashboard/campaigns/setup/define/advanced/$quality/$category/contacts": {
      id: "/_dashboard/campaigns/setup/define/advanced/$quality/$category/contacts"
      path: "/contacts"
      fullPath: "/campaigns/setup/define/advanced/$quality/$category/contacts"
      preLoaderRoute: typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryContactsRouteImport
      parentRoute: typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRoute
    }
    "/_dashboard/campaigns/setup/define/advanced/$quality/$category/$filter": {
      id: "/_dashboard/campaigns/setup/define/advanced/$quality/$category/$filter"
      path: "/$filter"
      fullPath: "/campaigns/setup/define/advanced/$quality/$category/$filter"
      preLoaderRoute: typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryFilterRouteImport
      parentRoute: typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/method": {
      id: "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/method"
      path: "/method"
      fullPath: "/campaigns/$id/delivery/setup/integration/method"
      preLoaderRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationMethodRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/configure": {
      id: "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/configure"
      path: "/configure"
      fullPath: "/campaigns/$id/delivery/setup/integration/configure"
      preLoaderRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationConfigureRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select": {
      id: "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select"
      path: "/select"
      fullPath: "/campaigns/$id/delivery/setup/integration/select"
      preLoaderRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category": {
      id: "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category"
      path: "/$category"
      fullPath: "/campaigns/$id/define/advanced/$quality/$category"
      preLoaderRoute: typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDefineAdvancedQualityRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select/": {
      id: "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select/"
      path: "/"
      fullPath: "/campaigns/$id/delivery/setup/integration/select/"
      preLoaderRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectIndexRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select/new": {
      id: "/_dashboard/campaigns/$id/(edit)/delivery/setup/integration/select/new"
      path: "/new"
      fullPath: "/campaigns/$id/delivery/setup/integration/select/new"
      preLoaderRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectNewRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category/contacts": {
      id: "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category/contacts"
      path: "/contacts"
      fullPath: "/campaigns/$id/define/advanced/$quality/$category/contacts"
      preLoaderRoute: typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryContactsRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRoute
    }
    "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category/$filter": {
      id: "/_dashboard/campaigns/$id/(edit)/define/advanced/$quality/$category/$filter"
      path: "/$filter"
      fullPath: "/campaigns/$id/define/advanced/$quality/$category/$filter"
      preLoaderRoute: typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryFilterRouteImport
      parentRoute: typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRoute
    }
  }
}

interface DashboardLeadsRouteRouteChildren {
  DashboardLeadsIndexRoute: typeof DashboardLeadsIndexRoute
}

const DashboardLeadsRouteRouteChildren: DashboardLeadsRouteRouteChildren = {
  DashboardLeadsIndexRoute: DashboardLeadsIndexRoute,
}

const DashboardLeadsRouteRouteWithChildren =
  DashboardLeadsRouteRoute._addFileChildren(DashboardLeadsRouteRouteChildren)

interface DashboardSettingsAdminDisabledRouteRouteChildren {
  DashboardSettingsAdminDisabledInvoicesIndexRoute: typeof DashboardSettingsAdminDisabledInvoicesIndexRoute
}

const DashboardSettingsAdminDisabledRouteRouteChildren: DashboardSettingsAdminDisabledRouteRouteChildren =
  {
    DashboardSettingsAdminDisabledInvoicesIndexRoute:
      DashboardSettingsAdminDisabledInvoicesIndexRoute,
  }

const DashboardSettingsAdminDisabledRouteRouteWithChildren =
  DashboardSettingsAdminDisabledRouteRoute._addFileChildren(
    DashboardSettingsAdminDisabledRouteRouteChildren,
  )

interface DashboardSettingsAdminIntegrationsRouteRouteChildren {
  DashboardSettingsAdminIntegrationsIndexRoute: typeof DashboardSettingsAdminIntegrationsIndexRoute
  DashboardSettingsAdminIntegrationsIntegrationConnectRoute: typeof DashboardSettingsAdminIntegrationsIntegrationConnectRoute
  DashboardSettingsAdminIntegrationsIntegrationSettingsRoute: typeof DashboardSettingsAdminIntegrationsIntegrationSettingsRoute
  DashboardSettingsAdminIntegrationsIntegrationModeIndexRoute: typeof DashboardSettingsAdminIntegrationsIntegrationModeIndexRoute
}

const DashboardSettingsAdminIntegrationsRouteRouteChildren: DashboardSettingsAdminIntegrationsRouteRouteChildren =
  {
    DashboardSettingsAdminIntegrationsIndexRoute:
      DashboardSettingsAdminIntegrationsIndexRoute,
    DashboardSettingsAdminIntegrationsIntegrationConnectRoute:
      DashboardSettingsAdminIntegrationsIntegrationConnectRoute,
    DashboardSettingsAdminIntegrationsIntegrationSettingsRoute:
      DashboardSettingsAdminIntegrationsIntegrationSettingsRoute,
    DashboardSettingsAdminIntegrationsIntegrationModeIndexRoute:
      DashboardSettingsAdminIntegrationsIntegrationModeIndexRoute,
  }

const DashboardSettingsAdminIntegrationsRouteRouteWithChildren =
  DashboardSettingsAdminIntegrationsRouteRoute._addFileChildren(
    DashboardSettingsAdminIntegrationsRouteRouteChildren,
  )

interface DashboardSettingsAdminStopListsRouteRouteChildren {
  DashboardSettingsAdminStopListsIndexRoute: typeof DashboardSettingsAdminStopListsIndexRoute
  DashboardSettingsAdminStopListsIdIndexRoute: typeof DashboardSettingsAdminStopListsIdIndexRoute
}

const DashboardSettingsAdminStopListsRouteRouteChildren: DashboardSettingsAdminStopListsRouteRouteChildren =
  {
    DashboardSettingsAdminStopListsIndexRoute:
      DashboardSettingsAdminStopListsIndexRoute,
    DashboardSettingsAdminStopListsIdIndexRoute:
      DashboardSettingsAdminStopListsIdIndexRoute,
  }

const DashboardSettingsAdminStopListsRouteRouteWithChildren =
  DashboardSettingsAdminStopListsRouteRoute._addFileChildren(
    DashboardSettingsAdminStopListsRouteRouteChildren,
  )

interface DashboardSettingsAdminSubscriptionSubscriptionRouteChildren {
  DashboardSettingsAdminSubscriptionSubscriptionAddCreditsRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionAddCreditsRoute
  DashboardSettingsAdminSubscriptionSubscriptionAddUsersRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionAddUsersRoute
  DashboardSettingsAdminSubscriptionSubscriptionCreditUsageRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionCreditUsageRoute
  DashboardSettingsAdminSubscriptionSubscriptionIndexRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionIndexRoute
}

const DashboardSettingsAdminSubscriptionSubscriptionRouteChildren: DashboardSettingsAdminSubscriptionSubscriptionRouteChildren =
  {
    DashboardSettingsAdminSubscriptionSubscriptionAddCreditsRoute:
      DashboardSettingsAdminSubscriptionSubscriptionAddCreditsRoute,
    DashboardSettingsAdminSubscriptionSubscriptionAddUsersRoute:
      DashboardSettingsAdminSubscriptionSubscriptionAddUsersRoute,
    DashboardSettingsAdminSubscriptionSubscriptionCreditUsageRoute:
      DashboardSettingsAdminSubscriptionSubscriptionCreditUsageRoute,
    DashboardSettingsAdminSubscriptionSubscriptionIndexRoute:
      DashboardSettingsAdminSubscriptionSubscriptionIndexRoute,
  }

const DashboardSettingsAdminSubscriptionSubscriptionRouteWithChildren =
  DashboardSettingsAdminSubscriptionSubscriptionRoute._addFileChildren(
    DashboardSettingsAdminSubscriptionSubscriptionRouteChildren,
  )

interface DashboardSettingsAdminUsersUsersRouteChildren {
  DashboardSettingsAdminUsersUsersAddUsersRoute: typeof DashboardSettingsAdminUsersUsersAddUsersRoute
  DashboardSettingsAdminUsersUsersInviteNewRoute: typeof DashboardSettingsAdminUsersUsersInviteNewRoute
  DashboardSettingsAdminUsersUsersIndexRoute: typeof DashboardSettingsAdminUsersUsersIndexRoute
}

const DashboardSettingsAdminUsersUsersRouteChildren: DashboardSettingsAdminUsersUsersRouteChildren =
  {
    DashboardSettingsAdminUsersUsersAddUsersRoute:
      DashboardSettingsAdminUsersUsersAddUsersRoute,
    DashboardSettingsAdminUsersUsersInviteNewRoute:
      DashboardSettingsAdminUsersUsersInviteNewRoute,
    DashboardSettingsAdminUsersUsersIndexRoute:
      DashboardSettingsAdminUsersUsersIndexRoute,
  }

const DashboardSettingsAdminUsersUsersRouteWithChildren =
  DashboardSettingsAdminUsersUsersRoute._addFileChildren(
    DashboardSettingsAdminUsersUsersRouteChildren,
  )

interface DashboardSettingsAdminRouteRouteChildren {
  DashboardSettingsAdminDisabledRouteRoute: typeof DashboardSettingsAdminDisabledRouteRouteWithChildren
  DashboardSettingsAdminIntegrationsRouteRoute: typeof DashboardSettingsAdminIntegrationsRouteRouteWithChildren
  DashboardSettingsAdminStopListsRouteRoute: typeof DashboardSettingsAdminStopListsRouteRouteWithChildren
  DashboardSettingsAdminSubscriptionSubscriptionRoute: typeof DashboardSettingsAdminSubscriptionSubscriptionRouteWithChildren
  DashboardSettingsAdminUsersUsersRoute: typeof DashboardSettingsAdminUsersUsersRouteWithChildren
  DashboardSettingsAdminCompanyIndexRoute: typeof DashboardSettingsAdminCompanyIndexRoute
  DashboardSettingsAdminUsersIdIndexRoute: typeof DashboardSettingsAdminUsersIdIndexRoute
}

const DashboardSettingsAdminRouteRouteChildren: DashboardSettingsAdminRouteRouteChildren =
  {
    DashboardSettingsAdminDisabledRouteRoute:
      DashboardSettingsAdminDisabledRouteRouteWithChildren,
    DashboardSettingsAdminIntegrationsRouteRoute:
      DashboardSettingsAdminIntegrationsRouteRouteWithChildren,
    DashboardSettingsAdminStopListsRouteRoute:
      DashboardSettingsAdminStopListsRouteRouteWithChildren,
    DashboardSettingsAdminSubscriptionSubscriptionRoute:
      DashboardSettingsAdminSubscriptionSubscriptionRouteWithChildren,
    DashboardSettingsAdminUsersUsersRoute:
      DashboardSettingsAdminUsersUsersRouteWithChildren,
    DashboardSettingsAdminCompanyIndexRoute:
      DashboardSettingsAdminCompanyIndexRoute,
    DashboardSettingsAdminUsersIdIndexRoute:
      DashboardSettingsAdminUsersIdIndexRoute,
  }

const DashboardSettingsAdminRouteRouteWithChildren =
  DashboardSettingsAdminRouteRoute._addFileChildren(
    DashboardSettingsAdminRouteRouteChildren,
  )

interface DashboardSettingsProfileProfileRouteChildren {
  DashboardSettingsProfileProfileIndexRoute: typeof DashboardSettingsProfileProfileIndexRoute
}

const DashboardSettingsProfileProfileRouteChildren: DashboardSettingsProfileProfileRouteChildren =
  {
    DashboardSettingsProfileProfileIndexRoute:
      DashboardSettingsProfileProfileIndexRoute,
  }

const DashboardSettingsProfileProfileRouteWithChildren =
  DashboardSettingsProfileProfileRoute._addFileChildren(
    DashboardSettingsProfileProfileRouteChildren,
  )

interface DashboardSettingsRouteRouteChildren {
  DashboardSettingsAdminRouteRoute: typeof DashboardSettingsAdminRouteRouteWithChildren
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
  DashboardSettingsProfileProfileRoute: typeof DashboardSettingsProfileProfileRouteWithChildren
}

const DashboardSettingsRouteRouteChildren: DashboardSettingsRouteRouteChildren =
  {
    DashboardSettingsAdminRouteRoute:
      DashboardSettingsAdminRouteRouteWithChildren,
    DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
    DashboardSettingsProfileProfileRoute:
      DashboardSettingsProfileProfileRouteWithChildren,
  }

const DashboardSettingsRouteRouteWithChildren =
  DashboardSettingsRouteRoute._addFileChildren(
    DashboardSettingsRouteRouteChildren,
  )

interface DashboardCampaignsIdeditBoostRouteRouteChildren {
  DashboardCampaignsIdeditBoostBuyCreditsRoute: typeof DashboardCampaignsIdeditBoostBuyCreditsRoute
  DashboardCampaignsIdeditBoostContactInformationRoute: typeof DashboardCampaignsIdeditBoostContactInformationRoute
  DashboardCampaignsIdeditBoostLeadAmountRoute: typeof DashboardCampaignsIdeditBoostLeadAmountRoute
}

const DashboardCampaignsIdeditBoostRouteRouteChildren: DashboardCampaignsIdeditBoostRouteRouteChildren =
  {
    DashboardCampaignsIdeditBoostBuyCreditsRoute:
      DashboardCampaignsIdeditBoostBuyCreditsRoute,
    DashboardCampaignsIdeditBoostContactInformationRoute:
      DashboardCampaignsIdeditBoostContactInformationRoute,
    DashboardCampaignsIdeditBoostLeadAmountRoute:
      DashboardCampaignsIdeditBoostLeadAmountRoute,
  }

const DashboardCampaignsIdeditBoostRouteRouteWithChildren =
  DashboardCampaignsIdeditBoostRouteRoute._addFileChildren(
    DashboardCampaignsIdeditBoostRouteRouteChildren,
  )

interface DashboardCampaignsIdeditDefineCategoryRouteRouteChildren {
  DashboardCampaignsIdeditDefineCategoryFilterRoute: typeof DashboardCampaignsIdeditDefineCategoryFilterRoute
  DashboardCampaignsIdeditDefineCategoryContactsRoute: typeof DashboardCampaignsIdeditDefineCategoryContactsRoute
  DashboardCampaignsIdeditDefineCategoryIndexRoute: typeof DashboardCampaignsIdeditDefineCategoryIndexRoute
}

const DashboardCampaignsIdeditDefineCategoryRouteRouteChildren: DashboardCampaignsIdeditDefineCategoryRouteRouteChildren =
  {
    DashboardCampaignsIdeditDefineCategoryFilterRoute:
      DashboardCampaignsIdeditDefineCategoryFilterRoute,
    DashboardCampaignsIdeditDefineCategoryContactsRoute:
      DashboardCampaignsIdeditDefineCategoryContactsRoute,
    DashboardCampaignsIdeditDefineCategoryIndexRoute:
      DashboardCampaignsIdeditDefineCategoryIndexRoute,
  }

const DashboardCampaignsIdeditDefineCategoryRouteRouteWithChildren =
  DashboardCampaignsIdeditDefineCategoryRouteRoute._addFileChildren(
    DashboardCampaignsIdeditDefineCategoryRouteRouteChildren,
  )

interface DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRouteChildren {
  DashboardCampaignsIdeditDefineAdvancedQualityCategoryFilterRoute: typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryFilterRoute
  DashboardCampaignsIdeditDefineAdvancedQualityCategoryContactsRoute: typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryContactsRoute
}

const DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRouteChildren: DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRouteChildren =
  {
    DashboardCampaignsIdeditDefineAdvancedQualityCategoryFilterRoute:
      DashboardCampaignsIdeditDefineAdvancedQualityCategoryFilterRoute,
    DashboardCampaignsIdeditDefineAdvancedQualityCategoryContactsRoute:
      DashboardCampaignsIdeditDefineAdvancedQualityCategoryContactsRoute,
  }

const DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRouteWithChildren =
  DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRoute._addFileChildren(
    DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRouteChildren,
  )

interface DashboardCampaignsIdeditDefineAdvancedQualityRouteRouteChildren {
  DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRoute: typeof DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRouteWithChildren
}

const DashboardCampaignsIdeditDefineAdvancedQualityRouteRouteChildren: DashboardCampaignsIdeditDefineAdvancedQualityRouteRouteChildren =
  {
    DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRoute:
      DashboardCampaignsIdeditDefineAdvancedQualityCategoryRouteRouteWithChildren,
  }

const DashboardCampaignsIdeditDefineAdvancedQualityRouteRouteWithChildren =
  DashboardCampaignsIdeditDefineAdvancedQualityRouteRoute._addFileChildren(
    DashboardCampaignsIdeditDefineAdvancedQualityRouteRouteChildren,
  )

interface DashboardCampaignsIdeditDefineAdvancedRouteRouteChildren {
  DashboardCampaignsIdeditDefineAdvancedQualityRouteRoute: typeof DashboardCampaignsIdeditDefineAdvancedQualityRouteRouteWithChildren
  DashboardCampaignsIdeditDefineAdvancedIndexRoute: typeof DashboardCampaignsIdeditDefineAdvancedIndexRoute
}

const DashboardCampaignsIdeditDefineAdvancedRouteRouteChildren: DashboardCampaignsIdeditDefineAdvancedRouteRouteChildren =
  {
    DashboardCampaignsIdeditDefineAdvancedQualityRouteRoute:
      DashboardCampaignsIdeditDefineAdvancedQualityRouteRouteWithChildren,
    DashboardCampaignsIdeditDefineAdvancedIndexRoute:
      DashboardCampaignsIdeditDefineAdvancedIndexRoute,
  }

const DashboardCampaignsIdeditDefineAdvancedRouteRouteWithChildren =
  DashboardCampaignsIdeditDefineAdvancedRouteRoute._addFileChildren(
    DashboardCampaignsIdeditDefineAdvancedRouteRouteChildren,
  )

interface DashboardCampaignsIdeditDefineRouteRouteChildren {
  DashboardCampaignsIdeditDefineCategoryRouteRoute: typeof DashboardCampaignsIdeditDefineCategoryRouteRouteWithChildren
  DashboardCampaignsIdeditDefineAdvancedRouteRoute: typeof DashboardCampaignsIdeditDefineAdvancedRouteRouteWithChildren
  DashboardCampaignsIdeditDefineStopListsRoute: typeof DashboardCampaignsIdeditDefineStopListsRoute
  DashboardCampaignsIdeditDefineIndexRoute: typeof DashboardCampaignsIdeditDefineIndexRoute
}

const DashboardCampaignsIdeditDefineRouteRouteChildren: DashboardCampaignsIdeditDefineRouteRouteChildren =
  {
    DashboardCampaignsIdeditDefineCategoryRouteRoute:
      DashboardCampaignsIdeditDefineCategoryRouteRouteWithChildren,
    DashboardCampaignsIdeditDefineAdvancedRouteRoute:
      DashboardCampaignsIdeditDefineAdvancedRouteRouteWithChildren,
    DashboardCampaignsIdeditDefineStopListsRoute:
      DashboardCampaignsIdeditDefineStopListsRoute,
    DashboardCampaignsIdeditDefineIndexRoute:
      DashboardCampaignsIdeditDefineIndexRoute,
  }

const DashboardCampaignsIdeditDefineRouteRouteWithChildren =
  DashboardCampaignsIdeditDefineRouteRoute._addFileChildren(
    DashboardCampaignsIdeditDefineRouteRouteChildren,
  )

interface DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRouteChildren {
  DashboardCampaignsIdeditDeliverySetupIntegrationSelectNewRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectNewRoute
  DashboardCampaignsIdeditDeliverySetupIntegrationSelectIndexRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectIndexRoute
}

const DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRouteChildren: DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRouteChildren =
  {
    DashboardCampaignsIdeditDeliverySetupIntegrationSelectNewRoute:
      DashboardCampaignsIdeditDeliverySetupIntegrationSelectNewRoute,
    DashboardCampaignsIdeditDeliverySetupIntegrationSelectIndexRoute:
      DashboardCampaignsIdeditDeliverySetupIntegrationSelectIndexRoute,
  }

const DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRouteWithChildren =
  DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRoute._addFileChildren(
    DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRouteChildren,
  )

interface DashboardCampaignsIdeditDeliverySetupIntegrationRouteRouteChildren {
  DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRouteWithChildren
  DashboardCampaignsIdeditDeliverySetupIntegrationConfigureRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationConfigureRoute
  DashboardCampaignsIdeditDeliverySetupIntegrationMethodRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationMethodRoute
}

const DashboardCampaignsIdeditDeliverySetupIntegrationRouteRouteChildren: DashboardCampaignsIdeditDeliverySetupIntegrationRouteRouteChildren =
  {
    DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRoute:
      DashboardCampaignsIdeditDeliverySetupIntegrationSelectRouteRouteWithChildren,
    DashboardCampaignsIdeditDeliverySetupIntegrationConfigureRoute:
      DashboardCampaignsIdeditDeliverySetupIntegrationConfigureRoute,
    DashboardCampaignsIdeditDeliverySetupIntegrationMethodRoute:
      DashboardCampaignsIdeditDeliverySetupIntegrationMethodRoute,
  }

const DashboardCampaignsIdeditDeliverySetupIntegrationRouteRouteWithChildren =
  DashboardCampaignsIdeditDeliverySetupIntegrationRouteRoute._addFileChildren(
    DashboardCampaignsIdeditDeliverySetupIntegrationRouteRouteChildren,
  )

interface DashboardCampaignsIdeditDeliverySetupRouteRouteChildren {
  DashboardCampaignsIdeditDeliverySetupIntegrationRouteRoute: typeof DashboardCampaignsIdeditDeliverySetupIntegrationRouteRouteWithChildren
  DashboardCampaignsIdeditDeliverySetupBuyCreditsRoute: typeof DashboardCampaignsIdeditDeliverySetupBuyCreditsRoute
  DashboardCampaignsIdeditDeliverySetupConfigureRoute: typeof DashboardCampaignsIdeditDeliverySetupConfigureRoute
  DashboardCampaignsIdeditDeliverySetupMethodRoute: typeof DashboardCampaignsIdeditDeliverySetupMethodRoute
}

const DashboardCampaignsIdeditDeliverySetupRouteRouteChildren: DashboardCampaignsIdeditDeliverySetupRouteRouteChildren =
  {
    DashboardCampaignsIdeditDeliverySetupIntegrationRouteRoute:
      DashboardCampaignsIdeditDeliverySetupIntegrationRouteRouteWithChildren,
    DashboardCampaignsIdeditDeliverySetupBuyCreditsRoute:
      DashboardCampaignsIdeditDeliverySetupBuyCreditsRoute,
    DashboardCampaignsIdeditDeliverySetupConfigureRoute:
      DashboardCampaignsIdeditDeliverySetupConfigureRoute,
    DashboardCampaignsIdeditDeliverySetupMethodRoute:
      DashboardCampaignsIdeditDeliverySetupMethodRoute,
  }

const DashboardCampaignsIdeditDeliverySetupRouteRouteWithChildren =
  DashboardCampaignsIdeditDeliverySetupRouteRoute._addFileChildren(
    DashboardCampaignsIdeditDeliverySetupRouteRouteChildren,
  )

interface DashboardCampaignsIdeditDeliveryRouteRouteChildren {
  DashboardCampaignsIdeditDeliverySetupRouteRoute: typeof DashboardCampaignsIdeditDeliverySetupRouteRouteWithChildren
  DashboardCampaignsIdeditDeliveryBuyCreditsRoute: typeof DashboardCampaignsIdeditDeliveryBuyCreditsRoute
  DashboardCampaignsIdeditDeliveryIndexRoute: typeof DashboardCampaignsIdeditDeliveryIndexRoute
}

const DashboardCampaignsIdeditDeliveryRouteRouteChildren: DashboardCampaignsIdeditDeliveryRouteRouteChildren =
  {
    DashboardCampaignsIdeditDeliverySetupRouteRoute:
      DashboardCampaignsIdeditDeliverySetupRouteRouteWithChildren,
    DashboardCampaignsIdeditDeliveryBuyCreditsRoute:
      DashboardCampaignsIdeditDeliveryBuyCreditsRoute,
    DashboardCampaignsIdeditDeliveryIndexRoute:
      DashboardCampaignsIdeditDeliveryIndexRoute,
  }

const DashboardCampaignsIdeditDeliveryRouteRouteWithChildren =
  DashboardCampaignsIdeditDeliveryRouteRoute._addFileChildren(
    DashboardCampaignsIdeditDeliveryRouteRouteChildren,
  )

interface DashboardCampaignsIdeditPlanningContactInformationRouteRouteChildren {
  DashboardCampaignsIdeditPlanningContactInformationBuyCreditsRoute: typeof DashboardCampaignsIdeditPlanningContactInformationBuyCreditsRoute
  DashboardCampaignsIdeditPlanningContactInformationIndexRoute: typeof DashboardCampaignsIdeditPlanningContactInformationIndexRoute
}

const DashboardCampaignsIdeditPlanningContactInformationRouteRouteChildren: DashboardCampaignsIdeditPlanningContactInformationRouteRouteChildren =
  {
    DashboardCampaignsIdeditPlanningContactInformationBuyCreditsRoute:
      DashboardCampaignsIdeditPlanningContactInformationBuyCreditsRoute,
    DashboardCampaignsIdeditPlanningContactInformationIndexRoute:
      DashboardCampaignsIdeditPlanningContactInformationIndexRoute,
  }

const DashboardCampaignsIdeditPlanningContactInformationRouteRouteWithChildren =
  DashboardCampaignsIdeditPlanningContactInformationRouteRoute._addFileChildren(
    DashboardCampaignsIdeditPlanningContactInformationRouteRouteChildren,
  )

interface DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRouteChildren {
  DashboardCampaignsIdeditPlanningLeadAmountAndPeriodBuyCreditsRoute: typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodBuyCreditsRoute
  DashboardCampaignsIdeditPlanningLeadAmountAndPeriodIndexRoute: typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodIndexRoute
}

const DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRouteChildren: DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRouteChildren =
  {
    DashboardCampaignsIdeditPlanningLeadAmountAndPeriodBuyCreditsRoute:
      DashboardCampaignsIdeditPlanningLeadAmountAndPeriodBuyCreditsRoute,
    DashboardCampaignsIdeditPlanningLeadAmountAndPeriodIndexRoute:
      DashboardCampaignsIdeditPlanningLeadAmountAndPeriodIndexRoute,
  }

const DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRouteWithChildren =
  DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRoute._addFileChildren(
    DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRouteChildren,
  )

interface DashboardCampaignsIdeditPlanningTriggersRouteRouteChildren {
  DashboardCampaignsIdeditPlanningTriggersTriggerIdRoute: typeof DashboardCampaignsIdeditPlanningTriggersTriggerIdRoute
  DashboardCampaignsIdeditPlanningTriggersIndexRoute: typeof DashboardCampaignsIdeditPlanningTriggersIndexRoute
}

const DashboardCampaignsIdeditPlanningTriggersRouteRouteChildren: DashboardCampaignsIdeditPlanningTriggersRouteRouteChildren =
  {
    DashboardCampaignsIdeditPlanningTriggersTriggerIdRoute:
      DashboardCampaignsIdeditPlanningTriggersTriggerIdRoute,
    DashboardCampaignsIdeditPlanningTriggersIndexRoute:
      DashboardCampaignsIdeditPlanningTriggersIndexRoute,
  }

const DashboardCampaignsIdeditPlanningTriggersRouteRouteWithChildren =
  DashboardCampaignsIdeditPlanningTriggersRouteRoute._addFileChildren(
    DashboardCampaignsIdeditPlanningTriggersRouteRouteChildren,
  )

interface DashboardCampaignsIdeditPlanningRouteRouteChildren {
  DashboardCampaignsIdeditPlanningContactInformationRouteRoute: typeof DashboardCampaignsIdeditPlanningContactInformationRouteRouteWithChildren
  DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRoute: typeof DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRouteWithChildren
  DashboardCampaignsIdeditPlanningTriggersRouteRoute: typeof DashboardCampaignsIdeditPlanningTriggersRouteRouteWithChildren
  DashboardCampaignsIdeditPlanningSalesStrategyAndPrioritizationRoute: typeof DashboardCampaignsIdeditPlanningSalesStrategyAndPrioritizationRoute
}

const DashboardCampaignsIdeditPlanningRouteRouteChildren: DashboardCampaignsIdeditPlanningRouteRouteChildren =
  {
    DashboardCampaignsIdeditPlanningContactInformationRouteRoute:
      DashboardCampaignsIdeditPlanningContactInformationRouteRouteWithChildren,
    DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRoute:
      DashboardCampaignsIdeditPlanningLeadAmountAndPeriodRouteRouteWithChildren,
    DashboardCampaignsIdeditPlanningTriggersRouteRoute:
      DashboardCampaignsIdeditPlanningTriggersRouteRouteWithChildren,
    DashboardCampaignsIdeditPlanningSalesStrategyAndPrioritizationRoute:
      DashboardCampaignsIdeditPlanningSalesStrategyAndPrioritizationRoute,
  }

const DashboardCampaignsIdeditPlanningRouteRouteWithChildren =
  DashboardCampaignsIdeditPlanningRouteRoute._addFileChildren(
    DashboardCampaignsIdeditPlanningRouteRouteChildren,
  )

interface DashboardCampaignsIdeditStartCampaignRouteRouteChildren {
  DashboardCampaignsIdeditStartCampaignBuyCreditsRoute: typeof DashboardCampaignsIdeditStartCampaignBuyCreditsRoute
  DashboardCampaignsIdeditStartCampaignIndexRoute: typeof DashboardCampaignsIdeditStartCampaignIndexRoute
}

const DashboardCampaignsIdeditStartCampaignRouteRouteChildren: DashboardCampaignsIdeditStartCampaignRouteRouteChildren =
  {
    DashboardCampaignsIdeditStartCampaignBuyCreditsRoute:
      DashboardCampaignsIdeditStartCampaignBuyCreditsRoute,
    DashboardCampaignsIdeditStartCampaignIndexRoute:
      DashboardCampaignsIdeditStartCampaignIndexRoute,
  }

const DashboardCampaignsIdeditStartCampaignRouteRouteWithChildren =
  DashboardCampaignsIdeditStartCampaignRouteRoute._addFileChildren(
    DashboardCampaignsIdeditStartCampaignRouteRouteChildren,
  )

interface DashboardCampaignsIdeditAdjustWeekWeekStartRouteRouteChildren {
  DashboardCampaignsIdeditAdjustWeekWeekStartBuyCreditsRoute: typeof DashboardCampaignsIdeditAdjustWeekWeekStartBuyCreditsRoute
  DashboardCampaignsIdeditAdjustWeekWeekStartIndexRoute: typeof DashboardCampaignsIdeditAdjustWeekWeekStartIndexRoute
}

const DashboardCampaignsIdeditAdjustWeekWeekStartRouteRouteChildren: DashboardCampaignsIdeditAdjustWeekWeekStartRouteRouteChildren =
  {
    DashboardCampaignsIdeditAdjustWeekWeekStartBuyCreditsRoute:
      DashboardCampaignsIdeditAdjustWeekWeekStartBuyCreditsRoute,
    DashboardCampaignsIdeditAdjustWeekWeekStartIndexRoute:
      DashboardCampaignsIdeditAdjustWeekWeekStartIndexRoute,
  }

const DashboardCampaignsIdeditAdjustWeekWeekStartRouteRouteWithChildren =
  DashboardCampaignsIdeditAdjustWeekWeekStartRouteRoute._addFileChildren(
    DashboardCampaignsIdeditAdjustWeekWeekStartRouteRouteChildren,
  )

interface DashboardCampaignsIdeditRouteRouteChildren {
  DashboardCampaignsIdeditBoostRouteRoute: typeof DashboardCampaignsIdeditBoostRouteRouteWithChildren
  DashboardCampaignsIdeditDefineRouteRoute: typeof DashboardCampaignsIdeditDefineRouteRouteWithChildren
  DashboardCampaignsIdeditDeliveryRouteRoute: typeof DashboardCampaignsIdeditDeliveryRouteRouteWithChildren
  DashboardCampaignsIdeditPlanningRouteRoute: typeof DashboardCampaignsIdeditPlanningRouteRouteWithChildren
  DashboardCampaignsIdeditStartCampaignRouteRoute: typeof DashboardCampaignsIdeditStartCampaignRouteRouteWithChildren
  DashboardCampaignsIdeditDetailsRoute: typeof DashboardCampaignsIdeditDetailsRoute
  DashboardCampaignsIdeditAdjustWeekWeekStartRouteRoute: typeof DashboardCampaignsIdeditAdjustWeekWeekStartRouteRouteWithChildren
}

const DashboardCampaignsIdeditRouteRouteChildren: DashboardCampaignsIdeditRouteRouteChildren =
  {
    DashboardCampaignsIdeditBoostRouteRoute:
      DashboardCampaignsIdeditBoostRouteRouteWithChildren,
    DashboardCampaignsIdeditDefineRouteRoute:
      DashboardCampaignsIdeditDefineRouteRouteWithChildren,
    DashboardCampaignsIdeditDeliveryRouteRoute:
      DashboardCampaignsIdeditDeliveryRouteRouteWithChildren,
    DashboardCampaignsIdeditPlanningRouteRoute:
      DashboardCampaignsIdeditPlanningRouteRouteWithChildren,
    DashboardCampaignsIdeditStartCampaignRouteRoute:
      DashboardCampaignsIdeditStartCampaignRouteRouteWithChildren,
    DashboardCampaignsIdeditDetailsRoute: DashboardCampaignsIdeditDetailsRoute,
    DashboardCampaignsIdeditAdjustWeekWeekStartRouteRoute:
      DashboardCampaignsIdeditAdjustWeekWeekStartRouteRouteWithChildren,
  }

const DashboardCampaignsIdeditRouteRouteWithChildren =
  DashboardCampaignsIdeditRouteRoute._addFileChildren(
    DashboardCampaignsIdeditRouteRouteChildren,
  )

interface DashboardCampaignsIdRouteRouteChildren {
  DashboardCampaignsIdeditRouteRoute: typeof DashboardCampaignsIdeditRouteRouteWithChildren
  DashboardCampaignsIdIndexRoute: typeof DashboardCampaignsIdIndexRoute
}

const DashboardCampaignsIdRouteRouteChildren: DashboardCampaignsIdRouteRouteChildren =
  {
    DashboardCampaignsIdeditRouteRoute:
      DashboardCampaignsIdeditRouteRouteWithChildren,
    DashboardCampaignsIdIndexRoute: DashboardCampaignsIdIndexRoute,
  }

const DashboardCampaignsIdRouteRouteWithChildren =
  DashboardCampaignsIdRouteRoute._addFileChildren(
    DashboardCampaignsIdRouteRouteChildren,
  )

interface DashboardCampaignsSetupDefineCategoryRouteRouteChildren {
  DashboardCampaignsSetupDefineCategoryFilterRoute: typeof DashboardCampaignsSetupDefineCategoryFilterRoute
  DashboardCampaignsSetupDefineCategoryContactsRoute: typeof DashboardCampaignsSetupDefineCategoryContactsRoute
  DashboardCampaignsSetupDefineCategoryIndexRoute: typeof DashboardCampaignsSetupDefineCategoryIndexRoute
}

const DashboardCampaignsSetupDefineCategoryRouteRouteChildren: DashboardCampaignsSetupDefineCategoryRouteRouteChildren =
  {
    DashboardCampaignsSetupDefineCategoryFilterRoute:
      DashboardCampaignsSetupDefineCategoryFilterRoute,
    DashboardCampaignsSetupDefineCategoryContactsRoute:
      DashboardCampaignsSetupDefineCategoryContactsRoute,
    DashboardCampaignsSetupDefineCategoryIndexRoute:
      DashboardCampaignsSetupDefineCategoryIndexRoute,
  }

const DashboardCampaignsSetupDefineCategoryRouteRouteWithChildren =
  DashboardCampaignsSetupDefineCategoryRouteRoute._addFileChildren(
    DashboardCampaignsSetupDefineCategoryRouteRouteChildren,
  )

interface DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRouteChildren {
  DashboardCampaignsSetupDefineAdvancedQualityCategoryFilterRoute: typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryFilterRoute
  DashboardCampaignsSetupDefineAdvancedQualityCategoryContactsRoute: typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryContactsRoute
}

const DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRouteChildren: DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRouteChildren =
  {
    DashboardCampaignsSetupDefineAdvancedQualityCategoryFilterRoute:
      DashboardCampaignsSetupDefineAdvancedQualityCategoryFilterRoute,
    DashboardCampaignsSetupDefineAdvancedQualityCategoryContactsRoute:
      DashboardCampaignsSetupDefineAdvancedQualityCategoryContactsRoute,
  }

const DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRouteWithChildren =
  DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRoute._addFileChildren(
    DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRouteChildren,
  )

interface DashboardCampaignsSetupDefineAdvancedQualityRouteRouteChildren {
  DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRoute: typeof DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRouteWithChildren
}

const DashboardCampaignsSetupDefineAdvancedQualityRouteRouteChildren: DashboardCampaignsSetupDefineAdvancedQualityRouteRouteChildren =
  {
    DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRoute:
      DashboardCampaignsSetupDefineAdvancedQualityCategoryRouteRouteWithChildren,
  }

const DashboardCampaignsSetupDefineAdvancedQualityRouteRouteWithChildren =
  DashboardCampaignsSetupDefineAdvancedQualityRouteRoute._addFileChildren(
    DashboardCampaignsSetupDefineAdvancedQualityRouteRouteChildren,
  )

interface DashboardCampaignsSetupDefineAdvancedRouteRouteChildren {
  DashboardCampaignsSetupDefineAdvancedQualityRouteRoute: typeof DashboardCampaignsSetupDefineAdvancedQualityRouteRouteWithChildren
  DashboardCampaignsSetupDefineAdvancedIndexRoute: typeof DashboardCampaignsSetupDefineAdvancedIndexRoute
}

const DashboardCampaignsSetupDefineAdvancedRouteRouteChildren: DashboardCampaignsSetupDefineAdvancedRouteRouteChildren =
  {
    DashboardCampaignsSetupDefineAdvancedQualityRouteRoute:
      DashboardCampaignsSetupDefineAdvancedQualityRouteRouteWithChildren,
    DashboardCampaignsSetupDefineAdvancedIndexRoute:
      DashboardCampaignsSetupDefineAdvancedIndexRoute,
  }

const DashboardCampaignsSetupDefineAdvancedRouteRouteWithChildren =
  DashboardCampaignsSetupDefineAdvancedRouteRoute._addFileChildren(
    DashboardCampaignsSetupDefineAdvancedRouteRouteChildren,
  )

interface DashboardCampaignsSetupDefineRouteRouteChildren {
  DashboardCampaignsSetupDefineCategoryRouteRoute: typeof DashboardCampaignsSetupDefineCategoryRouteRouteWithChildren
  DashboardCampaignsSetupDefineAdvancedRouteRoute: typeof DashboardCampaignsSetupDefineAdvancedRouteRouteWithChildren
  DashboardCampaignsSetupDefineStopListsRoute: typeof DashboardCampaignsSetupDefineStopListsRoute
  DashboardCampaignsSetupDefineIndexRoute: typeof DashboardCampaignsSetupDefineIndexRoute
}

const DashboardCampaignsSetupDefineRouteRouteChildren: DashboardCampaignsSetupDefineRouteRouteChildren =
  {
    DashboardCampaignsSetupDefineCategoryRouteRoute:
      DashboardCampaignsSetupDefineCategoryRouteRouteWithChildren,
    DashboardCampaignsSetupDefineAdvancedRouteRoute:
      DashboardCampaignsSetupDefineAdvancedRouteRouteWithChildren,
    DashboardCampaignsSetupDefineStopListsRoute:
      DashboardCampaignsSetupDefineStopListsRoute,
    DashboardCampaignsSetupDefineIndexRoute:
      DashboardCampaignsSetupDefineIndexRoute,
  }

const DashboardCampaignsSetupDefineRouteRouteWithChildren =
  DashboardCampaignsSetupDefineRouteRoute._addFileChildren(
    DashboardCampaignsSetupDefineRouteRouteChildren,
  )

interface DashboardCampaignsSetupDeliveryIntegrationSelectRouteRouteChildren {
  DashboardCampaignsSetupDeliveryIntegrationSelectNewRoute: typeof DashboardCampaignsSetupDeliveryIntegrationSelectNewRoute
  DashboardCampaignsSetupDeliveryIntegrationSelectIndexRoute: typeof DashboardCampaignsSetupDeliveryIntegrationSelectIndexRoute
}

const DashboardCampaignsSetupDeliveryIntegrationSelectRouteRouteChildren: DashboardCampaignsSetupDeliveryIntegrationSelectRouteRouteChildren =
  {
    DashboardCampaignsSetupDeliveryIntegrationSelectNewRoute:
      DashboardCampaignsSetupDeliveryIntegrationSelectNewRoute,
    DashboardCampaignsSetupDeliveryIntegrationSelectIndexRoute:
      DashboardCampaignsSetupDeliveryIntegrationSelectIndexRoute,
  }

const DashboardCampaignsSetupDeliveryIntegrationSelectRouteRouteWithChildren =
  DashboardCampaignsSetupDeliveryIntegrationSelectRouteRoute._addFileChildren(
    DashboardCampaignsSetupDeliveryIntegrationSelectRouteRouteChildren,
  )

interface DashboardCampaignsSetupDeliveryIntegrationRouteRouteChildren {
  DashboardCampaignsSetupDeliveryIntegrationSelectRouteRoute: typeof DashboardCampaignsSetupDeliveryIntegrationSelectRouteRouteWithChildren
  DashboardCampaignsSetupDeliveryIntegrationConfigureRoute: typeof DashboardCampaignsSetupDeliveryIntegrationConfigureRoute
  DashboardCampaignsSetupDeliveryIntegrationMethodRoute: typeof DashboardCampaignsSetupDeliveryIntegrationMethodRoute
}

const DashboardCampaignsSetupDeliveryIntegrationRouteRouteChildren: DashboardCampaignsSetupDeliveryIntegrationRouteRouteChildren =
  {
    DashboardCampaignsSetupDeliveryIntegrationSelectRouteRoute:
      DashboardCampaignsSetupDeliveryIntegrationSelectRouteRouteWithChildren,
    DashboardCampaignsSetupDeliveryIntegrationConfigureRoute:
      DashboardCampaignsSetupDeliveryIntegrationConfigureRoute,
    DashboardCampaignsSetupDeliveryIntegrationMethodRoute:
      DashboardCampaignsSetupDeliveryIntegrationMethodRoute,
  }

const DashboardCampaignsSetupDeliveryIntegrationRouteRouteWithChildren =
  DashboardCampaignsSetupDeliveryIntegrationRouteRoute._addFileChildren(
    DashboardCampaignsSetupDeliveryIntegrationRouteRouteChildren,
  )

interface DashboardCampaignsSetupDeliveryRouteRouteChildren {
  DashboardCampaignsSetupDeliveryIntegrationRouteRoute: typeof DashboardCampaignsSetupDeliveryIntegrationRouteRouteWithChildren
  DashboardCampaignsSetupDeliveryConfigureRoute: typeof DashboardCampaignsSetupDeliveryConfigureRoute
  DashboardCampaignsSetupDeliveryMethodRoute: typeof DashboardCampaignsSetupDeliveryMethodRoute
}

const DashboardCampaignsSetupDeliveryRouteRouteChildren: DashboardCampaignsSetupDeliveryRouteRouteChildren =
  {
    DashboardCampaignsSetupDeliveryIntegrationRouteRoute:
      DashboardCampaignsSetupDeliveryIntegrationRouteRouteWithChildren,
    DashboardCampaignsSetupDeliveryConfigureRoute:
      DashboardCampaignsSetupDeliveryConfigureRoute,
    DashboardCampaignsSetupDeliveryMethodRoute:
      DashboardCampaignsSetupDeliveryMethodRoute,
  }

const DashboardCampaignsSetupDeliveryRouteRouteWithChildren =
  DashboardCampaignsSetupDeliveryRouteRoute._addFileChildren(
    DashboardCampaignsSetupDeliveryRouteRouteChildren,
  )

interface DashboardCampaignsSetupPlanningTriggersRouteRouteChildren {
  DashboardCampaignsSetupPlanningTriggersTriggerIdRoute: typeof DashboardCampaignsSetupPlanningTriggersTriggerIdRoute
  DashboardCampaignsSetupPlanningTriggersIndexRoute: typeof DashboardCampaignsSetupPlanningTriggersIndexRoute
}

const DashboardCampaignsSetupPlanningTriggersRouteRouteChildren: DashboardCampaignsSetupPlanningTriggersRouteRouteChildren =
  {
    DashboardCampaignsSetupPlanningTriggersTriggerIdRoute:
      DashboardCampaignsSetupPlanningTriggersTriggerIdRoute,
    DashboardCampaignsSetupPlanningTriggersIndexRoute:
      DashboardCampaignsSetupPlanningTriggersIndexRoute,
  }

const DashboardCampaignsSetupPlanningTriggersRouteRouteWithChildren =
  DashboardCampaignsSetupPlanningTriggersRouteRoute._addFileChildren(
    DashboardCampaignsSetupPlanningTriggersRouteRouteChildren,
  )

interface DashboardCampaignsSetupPlanningRouteRouteChildren {
  DashboardCampaignsSetupPlanningTriggersRouteRoute: typeof DashboardCampaignsSetupPlanningTriggersRouteRouteWithChildren
  DashboardCampaignsSetupPlanningContactInformationRoute: typeof DashboardCampaignsSetupPlanningContactInformationRoute
  DashboardCampaignsSetupPlanningLeadAmountRoute: typeof DashboardCampaignsSetupPlanningLeadAmountRoute
  DashboardCampaignsSetupPlanningLeadAmountAndPeriodRoute: typeof DashboardCampaignsSetupPlanningLeadAmountAndPeriodRoute
  DashboardCampaignsSetupPlanningSalesStrategyAndPrioritizationRoute: typeof DashboardCampaignsSetupPlanningSalesStrategyAndPrioritizationRoute
  DashboardCampaignsSetupPlanningTypeRoute: typeof DashboardCampaignsSetupPlanningTypeRoute
}

const DashboardCampaignsSetupPlanningRouteRouteChildren: DashboardCampaignsSetupPlanningRouteRouteChildren =
  {
    DashboardCampaignsSetupPlanningTriggersRouteRoute:
      DashboardCampaignsSetupPlanningTriggersRouteRouteWithChildren,
    DashboardCampaignsSetupPlanningContactInformationRoute:
      DashboardCampaignsSetupPlanningContactInformationRoute,
    DashboardCampaignsSetupPlanningLeadAmountRoute:
      DashboardCampaignsSetupPlanningLeadAmountRoute,
    DashboardCampaignsSetupPlanningLeadAmountAndPeriodRoute:
      DashboardCampaignsSetupPlanningLeadAmountAndPeriodRoute,
    DashboardCampaignsSetupPlanningSalesStrategyAndPrioritizationRoute:
      DashboardCampaignsSetupPlanningSalesStrategyAndPrioritizationRoute,
    DashboardCampaignsSetupPlanningTypeRoute:
      DashboardCampaignsSetupPlanningTypeRoute,
  }

const DashboardCampaignsSetupPlanningRouteRouteWithChildren =
  DashboardCampaignsSetupPlanningRouteRoute._addFileChildren(
    DashboardCampaignsSetupPlanningRouteRouteChildren,
  )

interface DashboardCampaignsSetupRouteRouteChildren {
  DashboardCampaignsSetupDefineRouteRoute: typeof DashboardCampaignsSetupDefineRouteRouteWithChildren
  DashboardCampaignsSetupDeliveryRouteRoute: typeof DashboardCampaignsSetupDeliveryRouteRouteWithChildren
  DashboardCampaignsSetupPlanningRouteRoute: typeof DashboardCampaignsSetupPlanningRouteRouteWithChildren
  DashboardCampaignsSetupSummaryBuyCreditsRoute: typeof DashboardCampaignsSetupSummaryBuyCreditsRoute
  DashboardCampaignsSetupDetailsIndexRoute: typeof DashboardCampaignsSetupDetailsIndexRoute
  DashboardCampaignsSetupSummaryIndexRoute: typeof DashboardCampaignsSetupSummaryIndexRoute
}

const DashboardCampaignsSetupRouteRouteChildren: DashboardCampaignsSetupRouteRouteChildren =
  {
    DashboardCampaignsSetupDefineRouteRoute:
      DashboardCampaignsSetupDefineRouteRouteWithChildren,
    DashboardCampaignsSetupDeliveryRouteRoute:
      DashboardCampaignsSetupDeliveryRouteRouteWithChildren,
    DashboardCampaignsSetupPlanningRouteRoute:
      DashboardCampaignsSetupPlanningRouteRouteWithChildren,
    DashboardCampaignsSetupSummaryBuyCreditsRoute:
      DashboardCampaignsSetupSummaryBuyCreditsRoute,
    DashboardCampaignsSetupDetailsIndexRoute:
      DashboardCampaignsSetupDetailsIndexRoute,
    DashboardCampaignsSetupSummaryIndexRoute:
      DashboardCampaignsSetupSummaryIndexRoute,
  }

const DashboardCampaignsSetupRouteRouteWithChildren =
  DashboardCampaignsSetupRouteRoute._addFileChildren(
    DashboardCampaignsSetupRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardHiddenRouteRoute: typeof DashboardHiddenRouteRoute
  DashboardLeadsRouteRoute: typeof DashboardLeadsRouteRouteWithChildren
  DashboardSettingsRouteRoute: typeof DashboardSettingsRouteRouteWithChildren
  DashboardBuyCreditsRoute: typeof DashboardBuyCreditsRoute
  DashboardIntroVideoRoute: typeof DashboardIntroVideoRoute
  DashboardStartRoute: typeof DashboardStartRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardCampaignsIdRouteRoute: typeof DashboardCampaignsIdRouteRouteWithChildren
  DashboardCampaignsSetupRouteRoute: typeof DashboardCampaignsSetupRouteRouteWithChildren
  DashboardCampaignsIndexRoute: typeof DashboardCampaignsIndexRoute
  DashboardPerformanceIndexRoute: typeof DashboardPerformanceIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardHiddenRouteRoute: DashboardHiddenRouteRoute,
  DashboardLeadsRouteRoute: DashboardLeadsRouteRouteWithChildren,
  DashboardSettingsRouteRoute: DashboardSettingsRouteRouteWithChildren,
  DashboardBuyCreditsRoute: DashboardBuyCreditsRoute,
  DashboardIntroVideoRoute: DashboardIntroVideoRoute,
  DashboardStartRoute: DashboardStartRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardCampaignsIdRouteRoute: DashboardCampaignsIdRouteRouteWithChildren,
  DashboardCampaignsSetupRouteRoute:
    DashboardCampaignsSetupRouteRouteWithChildren,
  DashboardCampaignsIndexRoute: DashboardCampaignsIndexRoute,
  DashboardPerformanceIndexRoute: DashboardPerformanceIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

interface PlayerRouteRouteChildren {
  PlayerIdRoute: typeof PlayerIdRoute
}

const PlayerRouteRouteChildren: PlayerRouteRouteChildren = {
  PlayerIdRoute: PlayerIdRoute,
}

const PlayerRouteRouteWithChildren = PlayerRouteRoute._addFileChildren(
  PlayerRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  PlayerRouteRoute: PlayerRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
